{
  "_comment": "設備設定頁的翻譯表（SPEC #contract-app-ui：翻譯以 label_id 為 key）。原文 zh-Hant 在 kinio_ui_model.json；這裡是 en / ja / zh-Hans。三平台各一份、位元組相同（ci/check-l10n.sh 檢查缺漏）。key：label_id、<key>.help、<key>.confirm；事件名稱 event.<key>、依欄位值換的名字 event.<key>.<欄位>.<值>（UI 模型 events[].label_ids）。",
  "locales": [
    "en",
    "ja",
    "zh-Hans"
  ],
  "strings": {
    "air_quality.air_quality": {
      "en": "Air quality",
      "ja": "空気の質",
      "zh-Hans": "空气品质"
    },
    "air_quality.air_quality.enum.extremely_poor": {
      "en": "Extremely poor",
      "ja": "非常に悪い",
      "zh-Hans": "极差"
    },
    "air_quality.air_quality.enum.fair": {
      "en": "Fair",
      "ja": "普通",
      "zh-Hans": "普通"
    },
    "air_quality.air_quality.enum.good": {
      "en": "Good",
      "ja": "良好",
      "zh-Hans": "良好"
    },
    "air_quality.air_quality.enum.moderate": {
      "en": "Moderate",
      "ja": "やや悪い",
      "zh-Hans": "中等"
    },
    "air_quality.air_quality.enum.poor": {
      "en": "Poor",
      "ja": "悪い",
      "zh-Hans": "差"
    },
    "air_quality.air_quality.enum.unknown": {
      "en": "Unknown",
      "ja": "不明",
      "zh-Hans": "未知"
    },
    "air_quality.air_quality.enum.very_poor": {
      "en": "Very poor",
      "ja": "とても悪い",
      "zh-Hans": "很差"
    },
    "basic_information.hardware_version_string": {
      "en": "Hardware version",
      "ja": "ハードウェアバージョン",
      "zh-Hans": "硬件版本"
    },
    "basic_information.node_label": {
      "en": "Name",
      "ja": "名前",
      "zh-Hans": "名称"
    },
    "basic_information.product_name": {
      "en": "Model",
      "ja": "型番",
      "zh-Hans": "型号"
    },
    "basic_information.serial_number": {
      "en": "Serial number",
      "ja": "シリアル番号",
      "zh-Hans": "序号"
    },
    "basic_information.software_version_string": {
      "en": "Firmware version",
      "ja": "ファームウェアバージョン",
      "zh-Hans": "固件版本"
    },
    "boolean_state.state_value": {
      "en": "Status",
      "ja": "状態",
      "zh-Hans": "状态"
    },
    "cluster.air_quality": {
      "en": "Air quality",
      "ja": "空気の質",
      "zh-Hans": "空气品质"
    },
    "cluster.basic_information": {
      "en": "Device info",
      "ja": "デバイス情報",
      "zh-Hans": "设备信息"
    },
    "cluster.boolean_state": {
      "en": "Open/close / Leak",
      "ja": "開閉 / 漏水",
      "zh-Hans": "开合 / 漏水"
    },
    "cluster.color_control": {
      "en": "Color and color temperature",
      "ja": "色と色温度",
      "zh-Hans": "颜色与色温"
    },
    "cluster.dishwasher_mode": {
      "en": "Dishwasher mode",
      "ja": "食洗機モード",
      "zh-Hans": "洗碗模式"
    },
    "cluster.electrical_energy_measurement": {
      "en": "Total energy",
      "ja": "積算電力量",
      "zh-Hans": "累计用电"
    },
    "cluster.electrical_power_measurement": {
      "en": "Power usage",
      "ja": "電力使用",
      "zh-Hans": "用电"
    },
    "cluster.fan_control": {
      "en": "Fan",
      "ja": "ファン",
      "zh-Hans": "风扇"
    },
    "cluster.hepa_filter_monitoring": {
      "en": "Filter",
      "ja": "フィルター",
      "zh-Hans": "滤网"
    },
    "cluster.identify": {
      "en": "Find this device",
      "ja": "このデバイスを探す",
      "zh-Hans": "找到这台"
    },
    "cluster.illuminance_measurement": {
      "en": "Illuminance",
      "ja": "照度",
      "zh-Hans": "照度"
    },
    "cluster.kinio_analytics": {
      "en": "Smart analytics",
      "ja": "スマート分析",
      "zh-Hans": "智能分析"
    },
    "cluster.kinio_audio": {
      "en": "Volume",
      "ja": "音量",
      "zh-Hans": "音量"
    },
    "cluster.kinio_bed_presence": {
      "en": "In-bed detection",
      "ja": "在床検知",
      "zh-Hans": "在床侦测"
    },
    "cluster.kinio_call": {
      "en": "One-touch call",
      "ja": "ワンタッチ呼び出し",
      "zh-Hans": "一键呼叫"
    },
    "cluster.kinio_camera_light": {
      "en": "Night vision and lights",
      "ja": "ナイトビジョンとランプ",
      "zh-Hans": "夜视与指示灯"
    },
    "cluster.kinio_channel": {
      "en": "Channel settings",
      "ja": "チャンネル設定",
      "zh-Hans": "通道设置"
    },
    "cluster.kinio_doorbell": {
      "en": "Doorbell",
      "ja": "ドアベル",
      "zh-Hans": "门铃"
    },
    "cluster.kinio_firmware": {
      "en": "Firmware",
      "ja": "ファームウェア",
      "zh-Hans": "固件"
    },
    "cluster.kinio_floodlight": {
      "en": "Floodlight",
      "ja": "フラッドライト",
      "zh-Hans": "补光灯"
    },
    "cluster.kinio_halow": {
      "en": "HaLow",
      "ja": "HaLow",
      "zh-Hans": "HaLow"
    },
    "cluster.kinio_image": {
      "en": "Image settings",
      "ja": "映像設定",
      "zh-Hans": "影像设置"
    },
    "cluster.kinio_journey": {
      "en": "Sleep journey",
      "ja": "睡眠ジャーニー",
      "zh-Hans": "睡眠旅程"
    },
    "cluster.kinio_lens": {
      "en": "Lenses",
      "ja": "レンズ",
      "zh-Hans": "镜头"
    },
    "cluster.kinio_local_services": {
      "en": "Local services",
      "ja": "ローカルサービス",
      "zh-Hans": "本机服务"
    },
    "cluster.kinio_mic": {
      "en": "Microphone",
      "ja": "マイク",
      "zh-Hans": "麦克风"
    },
    "cluster.kinio_motion": {
      "en": "Motion detection",
      "ja": "動体検知",
      "zh-Hans": "移动侦测"
    },
    "cluster.kinio_mycam": {
      "en": "Home watch",
      "ja": "見守り",
      "zh-Hans": "看家"
    },
    "cluster.kinio_node": {
      "en": "Node network",
      "ja": "ノードのネットワーク",
      "zh-Hans": "节点网络"
    },
    "cluster.kinio_object_recognition": {
      "en": "AI recognition",
      "ja": "AI 認識",
      "zh-Hans": "AI 辨识"
    },
    "cluster.kinio_onvif": {
      "en": "ONVIF",
      "ja": "ONVIF",
      "zh-Hans": "ONVIF"
    },
    "cluster.kinio_power": {
      "en": "Power saving",
      "ja": "省電力",
      "zh-Hans": "省电"
    },
    "cluster.kinio_ptz": {
      "en": "Pan and tilt",
      "ja": "パン・チルト",
      "zh-Hans": "云台"
    },
    "cluster.kinio_recording": {
      "en": "Recording settings",
      "ja": "録画設定",
      "zh-Hans": "录像设置"
    },
    "cluster.kinio_sensor_alert": {
      "en": "Threshold alerts",
      "ja": "しきい値の通知",
      "zh-Hans": "越界提醒"
    },
    "cluster.kinio_siren": {
      "en": "Siren",
      "ja": "サイレン",
      "zh-Hans": "警报器"
    },
    "cluster.kinio_sleep_session": {
      "en": "Sleep records",
      "ja": "睡眠記録",
      "zh-Hans": "睡眠纪录"
    },
    "cluster.kinio_sound_detection": {
      "en": "Sound detection",
      "ja": "音検知",
      "zh-Hans": "声音侦测"
    },
    "cluster.kinio_sound_recognition": {
      "en": "Sound recognition",
      "ja": "音の認識",
      "zh-Hans": "声音辨识"
    },
    "cluster.kinio_soundscape": {
      "en": "Sleep sounds",
      "ja": "睡眠サウンド",
      "zh-Hans": "助眠声音"
    },
    "cluster.kinio_station": {
      "en": "Station control",
      "ja": "ステーション制御",
      "zh-Hans": "站控"
    },
    "cluster.kinio_storage": {
      "en": "Local storage",
      "ja": "ローカルストレージ",
      "zh-Hans": "本地存储"
    },
    "cluster.kinio_streaming": {
      "en": "Streaming",
      "ja": "ストリーミング",
      "zh-Hans": "串流"
    },
    "cluster.kinio_system": {
      "en": "System",
      "ja": "システム",
      "zh-Hans": "系统"
    },
    "cluster.kinio_tamper": {
      "en": "Tamper detection",
      "ja": "遮蔽検知",
      "zh-Hans": "遮挡侦测"
    },
    "cluster.kinio_thermostat_ext": {
      "en": "Advanced climate",
      "ja": "温度調節の詳細",
      "zh-Hans": "温控高级"
    },
    "cluster.kinio_tv": {
      "en": "TV",
      "ja": "テレビ",
      "zh-Hans": "电视"
    },
    "cluster.kinio_video": {
      "en": "Stream quality",
      "ja": "ストリーム画質",
      "zh-Hans": "串流画质"
    },
    "cluster.kinio_video_signal": {
      "en": "Video signal",
      "ja": "映像信号",
      "zh-Hans": "视频信号"
    },
    "cluster.laundry_washer_mode": {
      "en": "Wash mode",
      "ja": "洗濯モード",
      "zh-Hans": "洗衣模式"
    },
    "cluster.level_control": {
      "en": "Brightness",
      "ja": "明るさ",
      "zh-Hans": "亮度"
    },
    "cluster.media_input": {
      "en": "Input source",
      "ja": "入力ソース",
      "zh-Hans": "输入来源"
    },
    "cluster.media_playback": {
      "en": "Play",
      "ja": "再生",
      "zh-Hans": "播放"
    },
    "cluster.occupancy_sensing": {
      "en": "Occupancy detection",
      "ja": "在室検知",
      "zh-Hans": "有人侦测"
    },
    "cluster.on_off": {
      "en": "On/Off",
      "ja": "オン / オフ",
      "zh-Hans": "开关"
    },
    "cluster.operational_state": {
      "en": "Operating status",
      "ja": "運転状態",
      "zh-Hans": "运转状态"
    },
    "cluster.pm25_concentration_measurement": {
      "en": "PM2.5",
      "ja": "PM2.5",
      "zh-Hans": "PM2.5"
    },
    "cluster.power_source": {
      "en": "Power",
      "ja": "電源",
      "zh-Hans": "电源"
    },
    "cluster.refrigerator_alarm": {
      "en": "Alarm",
      "ja": "アラーム",
      "zh-Hans": "警报"
    },
    "cluster.refrigerator_and_temperature_controlled_cabinet_mode": {
      "en": "Refrigerator mode",
      "ja": "冷蔵庫モード",
      "zh-Hans": "冰箱模式"
    },
    "cluster.relative_humidity_measurement": {
      "en": "Humidity",
      "ja": "湿度",
      "zh-Hans": "湿度"
    },
    "cluster.rvc_clean_mode": {
      "en": "Cleaning mode",
      "ja": "掃除モード",
      "zh-Hans": "清洁模式"
    },
    "cluster.rvc_operational_state": {
      "en": "Operating status",
      "ja": "運転状態",
      "zh-Hans": "运转状态"
    },
    "cluster.rvc_run_mode": {
      "en": "Run mode",
      "ja": "運転モード",
      "zh-Hans": "运转模式"
    },
    "cluster.temperature_control": {
      "en": "Temperature",
      "ja": "温度",
      "zh-Hans": "温度"
    },
    "cluster.temperature_measurement": {
      "en": "Temperature",
      "ja": "温度",
      "zh-Hans": "温度"
    },
    "cluster.thermostat": {
      "en": "Climate",
      "ja": "温度調節",
      "zh-Hans": "温控"
    },
    "color_control.color_temperature_mireds": {
      "en": "Color temperature",
      "ja": "色温度",
      "zh-Hans": "色温"
    },
    "color_control.current_hue": {
      "en": "Hue",
      "ja": "色相",
      "zh-Hans": "色相"
    },
    "color_control.current_saturation": {
      "en": "Saturation",
      "ja": "彩度",
      "zh-Hans": "饱和度"
    },
    "dishwasher_mode.current_mode": {
      "en": "Dishwasher mode",
      "ja": "食洗機モード",
      "zh-Hans": "洗碗模式"
    },
    "dishwasher_mode.current_mode.enum.heavy": {
      "en": "Heavy",
      "ja": "強力",
      "zh-Hans": "强力"
    },
    "dishwasher_mode.current_mode.enum.light": {
      "en": "Light",
      "ja": "軽め",
      "zh-Hans": "轻度"
    },
    "dishwasher_mode.current_mode.enum.normal": {
      "en": "Normal",
      "ja": "標準",
      "zh-Hans": "标准"
    },
    "electrical_energy_measurement.cumulative_energy_imported": {
      "en": "Total energy",
      "ja": "積算電力量",
      "zh-Hans": "累计用电"
    },
    "electrical_power_measurement.active_current": {
      "en": "Current",
      "ja": "電流",
      "zh-Hans": "电流"
    },
    "electrical_power_measurement.active_power": {
      "en": "Current power",
      "ja": "現在の電力",
      "zh-Hans": "目前功率"
    },
    "electrical_power_measurement.voltage": {
      "en": "Voltage",
      "ja": "電圧",
      "zh-Hans": "电压"
    },
    "event.boolean_state.state_change": {
      "en": "Switch state changed",
      "ja": "開閉状態が変わりました",
      "zh-Hans": "开关状态变化"
    },
    "event.kinio_ai_compute.detection": {
      "en": "AI detection",
      "ja": "AI 検知",
      "zh-Hans": "AI 检测"
    },
    "event.kinio_analytics.crossing_counted": {
      "en": "People counting",
      "ja": "人数カウント",
      "zh-Hans": "人数统计"
    },
    "event.kinio_analytics.intrusion_detected": {
      "en": "Area intrusion",
      "ja": "エリア侵入",
      "zh-Hans": "区域入侵"
    },
    "event.kinio_analytics.line_crossed": {
      "en": "Line crossing",
      "ja": "ライン通過検知",
      "zh-Hans": "越线检测"
    },
    "event.kinio_analytics.object_left_or_taken": {
      "en": "Object left / removed",
      "ja": "置き去り / 持ち去り",
      "zh-Hans": "物品遗留 / 移走"
    },
    "event.kinio_analytics.object_left_or_taken.change.left": {
      "en": "Object left behind",
      "ja": "物が置き去りにされました",
      "zh-Hans": "有物品被遗留"
    },
    "event.kinio_analytics.object_left_or_taken.change.taken": {
      "en": "Object removed",
      "ja": "物が持ち去られました",
      "zh-Hans": "有物品被移走"
    },
    "event.kinio_call.request": {
      "en": "Device call",
      "ja": "デバイスからの呼び出し",
      "zh-Hans": "设备呼叫"
    },
    "event.kinio_credential.rejected": {
      "en": "Device certificate rejected",
      "ja": "デバイス証明書が拒否されました",
      "zh-Hans": "设备证书被拒"
    },
    "event.kinio_credential.renewed": {
      "en": "Device certificate renewed",
      "ja": "デバイス証明書を更新しました",
      "zh-Hans": "设备证书已更新"
    },
    "event.kinio_credential.rolled_back": {
      "en": "Device certificate renewal failed",
      "ja": "デバイス証明書の更新に失敗しました",
      "zh-Hans": "设备证书更新失败"
    },
    "event.kinio_debug.root_login_changed": {
      "en": "Root login setting changed",
      "ja": "root ログイン設定を変更しました",
      "zh-Hans": "root 登录开关变更"
    },
    "event.kinio_doorbell.auto_replied": {
      "en": "Auto-replied",
      "ja": "自動応答しました",
      "zh-Hans": "已自动回复"
    },
    "event.kinio_doorbell.missed": {
      "en": "Missed doorbell",
      "ja": "ドアベル不在着信",
      "zh-Hans": "门铃未接"
    },
    "event.kinio_doorbell.press": {
      "en": "Doorbell pressed",
      "ja": "ドアベルが押されました",
      "zh-Hans": "有人按门铃"
    },
    "event.kinio_firmware.ota_failed": {
      "en": "Firmware update failed",
      "ja": "ファームウェアの更新に失敗しました",
      "zh-Hans": "固件更新失败"
    },
    "event.kinio_firmware.ota_progress": {
      "en": "Firmware update progress",
      "ja": "ファームウェアの更新の進行状況",
      "zh-Hans": "固件更新进度"
    },
    "event.kinio_firmware.ota_started": {
      "en": "Firmware update started",
      "ja": "ファームウェアの更新を開始しました",
      "zh-Hans": "开始更新固件"
    },
    "event.kinio_firmware.ota_succeeded": {
      "en": "Firmware updated",
      "ja": "ファームウェアを更新しました",
      "zh-Hans": "固件已更新"
    },
    "event.kinio_motion.motion": {
      "en": "Motion detected",
      "ja": "動きを検知",
      "zh-Hans": "检测到移动"
    },
    "event.kinio_mycam.moved": {
      "en": "Camera was moved",
      "ja": "カメラが動かされました",
      "zh-Hans": "摄像头被移动"
    },
    "event.kinio_mycam.paused": {
      "en": "Camera paused",
      "ja": "カメラを一時停止しました",
      "zh-Hans": "摄像头暂停"
    },
    "event.kinio_mycam.power_unplugged": {
      "en": "Camera unplugged",
      "ja": "カメラの電源が抜けています",
      "zh-Hans": "摄像头没插电"
    },
    "event.kinio_mycam.resumed": {
      "en": "Camera resumed",
      "ja": "カメラを再開しました",
      "zh-Hans": "摄像头继续"
    },
    "event.kinio_object_recognition.object_detected": {
      "en": "Object detected",
      "ja": "物体を検知",
      "zh-Hans": "检测到物体"
    },
    "event.kinio_object_recognition.object_detected.object_type.package": {
      "en": "Package detected",
      "ja": "荷物を検知",
      "zh-Hans": "检测到包裹"
    },
    "event.kinio_object_recognition.object_detected.object_type.person": {
      "en": "Person detected",
      "ja": "人を検知",
      "zh-Hans": "检测到人"
    },
    "event.kinio_object_recognition.object_detected.object_type.pet": {
      "en": "Animal detected",
      "ja": "動物を検知",
      "zh-Hans": "检测到动物"
    },
    "event.kinio_object_recognition.object_detected.object_type.vehicle": {
      "en": "Vehicle detected",
      "ja": "車両を検知",
      "zh-Hans": "检测到车辆"
    },
    "event.kinio_plug.energy_report": {
      "en": "Energy report",
      "ja": "電力レポート",
      "zh-Hans": "用电回报"
    },
    "event.kinio_plug.fault": {
      "en": "Plug protection triggered",
      "ja": "プラグの保護機能が作動しました",
      "zh-Hans": "插座保护动作"
    },
    "event.kinio_plug.fault.kind.overcurrent": {
      "en": "Current too high",
      "ja": "電流が大きすぎます",
      "zh-Hans": "电流过大"
    },
    "event.kinio_plug.fault.kind.overload": {
      "en": "Overload protection",
      "ja": "過負荷保護",
      "zh-Hans": "过载保护"
    },
    "event.kinio_plug.fault.kind.overvoltage": {
      "en": "Voltage too high",
      "ja": "電圧が高すぎます",
      "zh-Hans": "电压过高"
    },
    "event.kinio_plug.fault.kind.undervoltage": {
      "en": "Voltage too low",
      "ja": "電圧が低すぎます",
      "zh-Hans": "电压过低"
    },
    "event.kinio_plug.schedule_fired": {
      "en": "Schedule ran",
      "ja": "スケジュールを実行しました",
      "zh-Hans": "排程动作"
    },
    "event.kinio_plug.switched": {
      "en": "Plug turned on / off",
      "ja": "プラグのオン / オフ",
      "zh-Hans": "插座开关"
    },
    "event.kinio_power.entering_sleep": {
      "en": "Going to sleep",
      "ja": "スリープに入ります",
      "zh-Hans": "进入睡眠"
    },
    "event.kinio_power.low_battery": {
      "en": "Low battery",
      "ja": "バッテリー残量低下",
      "zh-Hans": "电量低"
    },
    "event.kinio_power.woke": {
      "en": "Device woke up",
      "ja": "デバイスが起動しました",
      "zh-Hans": "设备唤醒"
    },
    "event.kinio_provisioning.wifi_reconfig_failed": {
      "en": "Wi-Fi change failed",
      "ja": "Wi-Fi の変更に失敗しました",
      "zh-Hans": "更换 Wi-Fi 失败"
    },
    "event.kinio_provisioning.wifi_reconfig_succeeded": {
      "en": "Wi-Fi changed",
      "ja": "Wi-Fi を変更しました",
      "zh-Hans": "已更换 Wi-Fi"
    },
    "event.kinio_ptz.move": {
      "en": "Pan/tilt moved",
      "ja": "パン・チルトが動きました",
      "zh-Hans": "云台转动"
    },
    "event.kinio_ptz.tracking": {
      "en": "Tracking",
      "ja": "追跡中",
      "zh-Hans": "追踪中"
    },
    "event.kinio_recording.clip_ready": {
      "en": "Recording clip ready",
      "ja": "録画クリップを再生できます",
      "zh-Hans": "录像片段可播放"
    },
    "event.kinio_recording.cloud_fault": {
      "en": "Cloud recording problem",
      "ja": "クラウド録画の異常",
      "zh-Hans": "云端录像异常"
    },
    "event.kinio_recording.interrupted": {
      "en": "Recording interrupted",
      "ja": "録画が中断されました",
      "zh-Hans": "录像中断"
    },
    "event.kinio_recording.segment_failed": {
      "en": "Recording clip upload failed",
      "ja": "録画クリップのアップロードに失敗しました",
      "zh-Hans": "录像片段上传失败"
    },
    "event.kinio_recording.segment_uploaded": {
      "en": "Recording clip uploaded",
      "ja": "録画クリップをアップロードしました",
      "zh-Hans": "已上传录像片段"
    },
    "event.kinio_recording.started": {
      "en": "Recording started",
      "ja": "録画を開始しました",
      "zh-Hans": "开始录像"
    },
    "event.kinio_recording.stopped": {
      "en": "Recording stopped",
      "ja": "録画を停止しました",
      "zh-Hans": "停止录像"
    },
    "event.kinio_security.home_deleted": {
      "en": "Home deleted",
      "ja": "ホームが削除されました",
      "zh-Hans": "家庭已删除"
    },
    "event.kinio_security.mode_changed": {
      "en": "Security mode changed",
      "ja": "警戒モードを変更しました",
      "zh-Hans": "警戒模式变更"
    },
    "event.kinio_sensor_alert.humidity_high": {
      "en": "Humidity too high",
      "ja": "湿度が高すぎます",
      "zh-Hans": "湿度过高"
    },
    "event.kinio_sensor_alert.humidity_low": {
      "en": "Humidity too low",
      "ja": "湿度が低すぎます",
      "zh-Hans": "湿度过低"
    },
    "event.kinio_sensor_alert.temp_high": {
      "en": "Temperature too high",
      "ja": "温度が高すぎます",
      "zh-Hans": "温度过高"
    },
    "event.kinio_sensor_alert.temp_low": {
      "en": "Temperature too low",
      "ja": "温度が低すぎます",
      "zh-Hans": "温度过低"
    },
    "event.kinio_sound_detection.threshold_exceeded": {
      "en": "Sound detected",
      "ja": "音を検知",
      "zh-Hans": "检测到声音"
    },
    "event.kinio_sound_recognition.sound_detected": {
      "en": "Sound recognized",
      "ja": "音を識別しました",
      "zh-Hans": "识别到声音"
    },
    "event.kinio_sound_recognition.sound_detected.sound_class.baby_cry": {
      "en": "Crying heard",
      "ja": "泣き声を検知",
      "zh-Hans": "听到哭声"
    },
    "event.kinio_sound_recognition.sound_detected.sound_class.cat": {
      "en": "Cat meowing heard",
      "ja": "猫の鳴き声を検知",
      "zh-Hans": "听到猫叫"
    },
    "event.kinio_sound_recognition.sound_detected.sound_class.co_alarm": {
      "en": "Carbon monoxide alarm heard",
      "ja": "一酸化炭素警報音を検知",
      "zh-Hans": "听到一氧化碳警报声"
    },
    "event.kinio_sound_recognition.sound_detected.sound_class.dog": {
      "en": "Dog barking heard",
      "ja": "犬の鳴き声を検知",
      "zh-Hans": "听到狗叫"
    },
    "event.kinio_sound_recognition.sound_detected.sound_class.glass_break": {
      "en": "Glass breaking heard",
      "ja": "ガラスの割れる音を検知",
      "zh-Hans": "听到玻璃破裂"
    },
    "event.kinio_sound_recognition.sound_detected.sound_class.gunshot": {
      "en": "Possible gunshot heard",
      "ja": "銃声らしき音を検知",
      "zh-Hans": "听到疑似枪声"
    },
    "event.kinio_sound_recognition.sound_detected.sound_class.other": {
      "en": "Sound recognized",
      "ja": "音を識別しました",
      "zh-Hans": "识别到声音"
    },
    "event.kinio_sound_recognition.sound_detected.sound_class.scream": {
      "en": "Call for help heard",
      "ja": "助けを求める声を検知",
      "zh-Hans": "听到呼救声"
    },
    "event.kinio_sound_recognition.sound_detected.sound_class.smoke_alarm": {
      "en": "Smoke alarm heard",
      "ja": "煙警報音を検知",
      "zh-Hans": "听到烟雾警报声"
    },
    "event.kinio_storage.error": {
      "en": "Memory card problem",
      "ja": "メモリーカードの異常",
      "zh-Hans": "存储卡异常"
    },
    "event.kinio_storage.inserted": {
      "en": "Memory card inserted",
      "ja": "メモリーカードが挿入されました",
      "zh-Hans": "插入存储卡"
    },
    "event.kinio_storage.removed": {
      "en": "Memory card removed",
      "ja": "メモリーカードが取り出されました",
      "zh-Hans": "取出存储卡"
    },
    "event.kinio_subg.left": {
      "en": "Sub-device left",
      "ja": "子デバイスが離脱しました",
      "zh-Hans": "子设备已离开"
    },
    "event.kinio_subg.pair_failed": {
      "en": "Sub-device couldn't be added",
      "ja": "子デバイスの追加に失敗しました",
      "zh-Hans": "子设备加入失败"
    },
    "event.kinio_subg.paired": {
      "en": "Sub-device added",
      "ja": "子デバイスを追加しました",
      "zh-Hans": "子设备已加入"
    },
    "event.kinio_system.booted": {
      "en": "Device started",
      "ja": "デバイス起動",
      "zh-Hans": "设备开机"
    },
    "event.kinio_system.booted.reason.power_on": {
      "en": "Powered on (power restored after an outage)",
      "ja": "電源投入で起動（停電後の再通電）",
      "zh-Hans": "上电开机（断电后重新通电）"
    },
    "event.kinio_system.booted.reason.reset": {
      "en": "Restarted (the device restarted itself)",
      "ja": "リセットで起動（デバイスが自動で再起動）",
      "zh-Hans": "重置开机（设备自己重启）"
    },
    "event.kinio_system.booted.reason.watchdog": {
      "en": "Restarted by watchdog",
      "ja": "ウォッチドッグによる再起動",
      "zh-Hans": "看门狗重启"
    },
    "event.kinio_system.connected": {
      "en": "Reconnected",
      "ja": "再接続",
      "zh-Hans": "重新连上"
    },
    "event.kinio_system.connection_report": {
      "en": "Connection report",
      "ja": "接続レポート",
      "zh-Hans": "连接报告"
    },
    "event.kinio_system.disconnected": {
      "en": "Disconnected",
      "ja": "切断",
      "zh-Hans": "断线"
    },
    "event.kinio_system.events_suppressed": {
      "en": "Too many events, merged",
      "ja": "イベント多数のため集約",
      "zh-Hans": "事件太多，暂时合并"
    },
    "event.kinio_system.exception_report": {
      "en": "Device restarted after an error",
      "ja": "デバイスが異常で再起動しました",
      "zh-Hans": "设备异常重启"
    },
    "event.kinio_system.factory_reset_initiated": {
      "en": "Device reset to factory settings",
      "ja": "デバイスが工場出荷時の設定に戻りました",
      "zh-Hans": "设备已恢复出厂设置"
    },
    "event.kinio_system.unbound": {
      "en": "Device removed",
      "ja": "デバイスが削除されました",
      "zh-Hans": "设备已移除"
    },
    "event.kinio_tamper.tampered": {
      "en": "Camera blocked",
      "ja": "カメラが遮られました",
      "zh-Hans": "镜头被遮挡"
    },
    "event.kinio_video_signal.video_loss": {
      "en": "Video signal lost",
      "ja": "映像信号が途切れました",
      "zh-Hans": "视频信号中断"
    },
    "event.kmgr_alert.escalated": {
      "en": "KMS incident escalated",
      "ja": "KMS インシデントがエスカレート",
      "zh-Hans": "KMS 事故已升级"
    },
    "event.kmgr_alert.opened": {
      "en": "KMS incident",
      "ja": "KMS インシデント",
      "zh-Hans": "KMS 事故"
    },
    "event.kmgr_alert.resolved": {
      "en": "KMS incident resolved",
      "ja": "KMS インシデント復旧",
      "zh-Hans": "KMS 事故已恢复"
    },
    "event.occupancy_sensing.occupancy_changed": {
      "en": "Occupied / vacant",
      "ja": "在室 / 不在",
      "zh-Hans": "有人 / 无人"
    },
    "event.switch.initial_press": {
      "en": "Pressed",
      "ja": "押された",
      "zh-Hans": "按下"
    },
    "event.switch.long_press": {
      "en": "Long press",
      "ja": "長押し",
      "zh-Hans": "长按"
    },
    "event.switch.long_release": {
      "en": "Long press released",
      "ja": "長押し解除",
      "zh-Hans": "长按松开"
    },
    "event.switch.multi_press_complete": {
      "en": "Multi-press",
      "ja": "連続押し",
      "zh-Hans": "连按"
    },
    "event.switch.short_release": {
      "en": "Short press",
      "ja": "短押し",
      "zh-Hans": "短按"
    },
    "fan_control.fan_mode": {
      "en": "Fan speed",
      "ja": "風速",
      "zh-Hans": "风速"
    },
    "fan_control.fan_mode.enum.auto": {
      "en": "Auto",
      "ja": "自動",
      "zh-Hans": "自动"
    },
    "fan_control.fan_mode.enum.high": {
      "en": "High",
      "ja": "高",
      "zh-Hans": "高"
    },
    "fan_control.fan_mode.enum.low": {
      "en": "Low",
      "ja": "低",
      "zh-Hans": "低"
    },
    "fan_control.fan_mode.enum.medium": {
      "en": "Medium",
      "ja": "中",
      "zh-Hans": "中"
    },
    "fan_control.fan_mode.enum.off": {
      "en": "Off",
      "ja": "オフ",
      "zh-Hans": "关闭"
    },
    "fan_control.fan_mode.enum.on": {
      "en": "On",
      "ja": "オン",
      "zh-Hans": "打开"
    },
    "fan_control.fan_mode.enum.smart": {
      "en": "Smart",
      "ja": "スマート",
      "zh-Hans": "智能"
    },
    "fan_control.percent_current": {
      "en": "Current airflow",
      "ja": "現在の風量",
      "zh-Hans": "目前风量"
    },
    "fan_control.percent_setting": {
      "en": "Airflow",
      "ja": "風量",
      "zh-Hans": "风量"
    },
    "hepa_filter_monitoring.condition": {
      "en": "Filter life remaining",
      "ja": "フィルターの残り寿命",
      "zh-Hans": "滤网剩余寿命"
    },
    "hepa_filter_monitoring.reset_condition": {
      "en": "Reset filter life",
      "ja": "フィルター寿命をリセット",
      "zh-Hans": "重设滤网寿命"
    },
    "hepa_filter_monitoring.reset_condition.confirm": {
      "en": "Reset only after replacing the filter. Filter life will go back to 100%.",
      "ja": "新しいフィルターに交換してからリセットしてください。フィルター寿命が 100% に戻ります。",
      "zh-Hans": "请在更换新滤网后再重设，滤网寿命会回到 100%。"
    },
    "identify.identify_time": {
      "en": "Blink to find this device",
      "ja": "ライトを点滅させて探す",
      "zh-Hans": "闪灯找到这台"
    },
    "identify.identify_time.preset.0": {
      "en": "Don't blink",
      "ja": "点滅しない",
      "zh-Hans": "不闪"
    },
    "identify.identify_time.preset.10": {
      "en": "Blink for 10 seconds",
      "ja": "10 秒間点滅",
      "zh-Hans": "闪灯 10 秒"
    },
    "identify.identify_time.preset.60": {
      "en": "Blink for 1 minute",
      "ja": "1 分間点滅",
      "zh-Hans": "闪灯 1 分钟"
    },
    "illuminance_measurement.measured_value": {
      "en": "Illuminance",
      "ja": "照度",
      "zh-Hans": "照度"
    },
    "kinio_analytics.actions": {
      "en": "Actions",
      "ja": "連動動作",
      "zh-Hans": "触发动作"
    },
    "kinio_analytics.cross_counting": {
      "en": "People counting",
      "ja": "入退場カウント",
      "zh-Hans": "进出计数"
    },
    "kinio_analytics.enabled": {
      "en": "Advanced analytics",
      "ja": "高度な分析",
      "zh-Hans": "高级分析"
    },
    "kinio_analytics.face_detection": {
      "en": "Face detection",
      "ja": "顔検知",
      "zh-Hans": "人脸侦测"
    },
    "kinio_analytics.face_detection.confirm": {
      "en": "Faces are biometric data, and some places require notice or consent. Turn on?",
      "ja": "顔は生体情報にあたり、地域によっては告知や同意が必要です。オンにしますか？",
      "zh-Hans": "人脸属于生物特征数据，部分地区需要告知或取得同意。确定要打开？"
    },
    "kinio_analytics.heatmap": {
      "en": "Heat map",
      "ja": "ヒートマップ",
      "zh-Hans": "热点图"
    },
    "kinio_analytics.intrusion": {
      "en": "Intrusion",
      "ja": "エリア侵入",
      "zh-Hans": "区域入侵"
    },
    "kinio_analytics.line_crossing": {
      "en": "Line crossing",
      "ja": "ライン通過検知",
      "zh-Hans": "跨线侦测"
    },
    "kinio_analytics.object_left_taken": {
      "en": "Object left or removed",
      "ja": "置き去り・持ち去り",
      "zh-Hans": "物品遗留与移除"
    },
    "kinio_analytics.pedestrian_vehicle": {
      "en": "People and vehicle detection",
      "ja": "人・車両検知",
      "zh-Hans": "人车侦测"
    },
    "kinio_analytics.scene": {
      "en": "Scene",
      "ja": "シーン",
      "zh-Hans": "场景"
    },
    "kinio_analytics.scene.enum.indoor": {
      "en": "Indoor",
      "ja": "屋内",
      "zh-Hans": "室内"
    },
    "kinio_analytics.scene.enum.outdoor": {
      "en": "Outdoor",
      "ja": "屋外",
      "zh-Hans": "室外"
    },
    "kinio_analytics.schedule": {
      "en": "Active hours",
      "ja": "有効な時間帯",
      "zh-Hans": "生效时段"
    },
    "kinio_audio.mic_volume": {
      "en": "Microphone volume",
      "ja": "マイク音量",
      "zh-Hans": "麦克风音量"
    },
    "kinio_audio.speaker_mute": {
      "en": "Mute",
      "ja": "ミュート",
      "zh-Hans": "静音"
    },
    "kinio_audio.speaker_volume": {
      "en": "Speaker volume",
      "ja": "スピーカー音量",
      "zh-Hans": "喇叭音量"
    },
    "kinio_bed_presence.in_bed": {
      "en": "In bed",
      "ja": "在床",
      "zh-Hans": "在床"
    },
    "kinio_bed_presence.present": {
      "en": "Someone present",
      "ja": "在室",
      "zh-Hans": "有人"
    },
    "kinio_bed_presence.radar_enabled": {
      "en": "Radar",
      "ja": "レーダー",
      "zh-Hans": "雷达"
    },
    "kinio_bed_presence.radar_enabled.help": {
      "en": "When off, lights, sound and climate keep working; only in-bed and movement detection stop",
      "ja": "オフにしても照明・音・空調はそのまま使え、在床と体動の検知だけが止まります",
      "zh-Hans": "关闭后灯、声、空调照常，只失去在床与体动"
    },
    "kinio_call.enabled": {
      "en": "Call button",
      "ja": "呼び出しボタン",
      "zh-Hans": "呼叫键"
    },
    "kinio_call.ring_timeout_seconds": {
      "en": "Ring duration",
      "ja": "鳴動時間",
      "zh-Hans": "响铃时长"
    },
    "kinio_call.ring_timeout_seconds.preset.15": {
      "en": "15 seconds",
      "ja": "15 秒",
      "zh-Hans": "15 秒"
    },
    "kinio_call.ring_timeout_seconds.preset.30": {
      "en": "30 seconds (recommended)",
      "ja": "30 秒（推奨）",
      "zh-Hans": "30 秒（建议）"
    },
    "kinio_call.ring_timeout_seconds.preset.45": {
      "en": "45 seconds",
      "ja": "45 秒",
      "zh-Hans": "45 秒"
    },
    "kinio_call.ring_timeout_seconds.preset.60": {
      "en": "60 seconds",
      "ja": "60 秒",
      "zh-Hans": "60 秒"
    },
    "kinio_camera_light.night_enter_lux": {
      "en": "Night switch-on illuminance",
      "ja": "夜間に切り替える照度",
      "zh-Hans": "切换到夜间的照度"
    },
    "kinio_camera_light.night_enter_lux.help": {
      "en": "Switches to night when ambient light falls below this value",
      "ja": "周囲の照度がこの値を下回ると夜間に切り替わります",
      "zh-Hans": "环境照度低于这个值就切换到夜间"
    },
    "kinio_camera_light.night_exit_lux": {
      "en": "Day switch-back illuminance",
      "ja": "昼間に戻す照度",
      "zh-Hans": "回到白天的照度"
    },
    "kinio_camera_light.night_exit_lux.help": {
      "en": "Returns to day only when ambient light rises above this value; must be higher than the night switch-on illuminance",
      "ja": "周囲の照度がこの値を上回ると昼間に戻ります。夜間に切り替える照度より高くしてください",
      "zh-Hans": "环境照度高于这个值才回到白天；要比切换到夜间的照度高"
    },
    "kinio_camera_light.night_image": {
      "en": "Night image",
      "ja": "夜間の映像",
      "zh-Hans": "夜间画面"
    },
    "kinio_camera_light.night_image.enum.color": {
      "en": "Full color",
      "ja": "フルカラー",
      "zh-Hans": "全彩"
    },
    "kinio_camera_light.night_image.enum.mono": {
      "en": "Black and white",
      "ja": "白黒",
      "zh-Hans": "黑白"
    },
    "kinio_camera_light.night_image.help": {
      "en": "Keep the image in color or switch to black and white after dark; the light is set separately under \"Night vision\"",
      "ja": "暗くなったときに映像をカラーのままにするか白黒に切り替えます。補助光は「ナイトビジョン」で別に設定します",
      "zh-Hans": "天黑时画面维持彩色或转成黑白；补光灯另外在“夜视”设置"
    },
    "kinio_camera_light.night_mode": {
      "en": "Night vision",
      "ja": "ナイトビジョン",
      "zh-Hans": "夜视"
    },
    "kinio_camera_light.night_mode.enum.auto": {
      "en": "Auto (recommended)",
      "ja": "自動（推奨）",
      "zh-Hans": "自动（建议）"
    },
    "kinio_camera_light.night_mode.enum.off": {
      "en": "Off",
      "ja": "オフ",
      "zh-Hans": "关闭"
    },
    "kinio_camera_light.night_mode.enum.on": {
      "en": "Always on",
      "ja": "常にオン",
      "zh-Hans": "一律打开"
    },
    "kinio_camera_light.status_light": {
      "en": "Status light",
      "ja": "状態ランプ",
      "zh-Hans": "状态指示灯"
    },
    "kinio_camera_light.warning_indicator": {
      "en": "Warning light",
      "ja": "警告ランプ",
      "zh-Hans": "警示指示灯"
    },
    "kinio_channel.audio": {
      "en": "Audio",
      "ja": "音声",
      "zh-Hans": "音频"
    },
    "kinio_channel.bitrate": {
      "en": "Bitrate",
      "ja": "ビットレート",
      "zh-Hans": "比特率"
    },
    "kinio_channel.codec": {
      "en": "Codec",
      "ja": "コーデック",
      "zh-Hans": "编码"
    },
    "kinio_channel.covert": {
      "en": "Hide this channel",
      "ja": "このチャンネルを非表示",
      "zh-Hans": "隐藏此通道"
    },
    "kinio_channel.custom_slot": {
      "en": "Custom protocol slot",
      "ja": "カスタムプロトコル番号",
      "zh-Hans": "自订协议编号"
    },
    "kinio_channel.error": {
      "en": "Error",
      "ja": "エラー",
      "zh-Hans": "错误"
    },
    "kinio_channel.factory_reset": {
      "en": "Factory reset camera",
      "ja": "カメラを工場出荷時設定に戻す",
      "zh-Hans": "摄像头原厂重置"
    },
    "kinio_channel.factory_reset.confirm": {
      "en": "All settings on this camera will be erased.",
      "ja": "このカメラのすべての設定が消去されます。",
      "zh-Hans": "这台摄像头的所有设置会被清除。"
    },
    "kinio_channel.fps": {
      "en": "Frame rate",
      "ja": "フレームレート",
      "zh-Hans": "帧率"
    },
    "kinio_channel.height": {
      "en": "Height",
      "ja": "高さ",
      "zh-Hans": "高度"
    },
    "kinio_channel.host": {
      "en": "Address",
      "ja": "アドレス",
      "zh-Hans": "地址"
    },
    "kinio_channel.main_url": {
      "en": "Main stream path",
      "ja": "メインストリームのパス",
      "zh-Hans": "主串流路径"
    },
    "kinio_channel.port": {
      "en": "Port",
      "ja": "ポート",
      "zh-Hans": "连接端口"
    },
    "kinio_channel.protocol": {
      "en": "Protocol",
      "ja": "プロトコル",
      "zh-Hans": "连接协议"
    },
    "kinio_channel.protocol.enum.custom": {
      "en": "Custom protocol",
      "ja": "カスタムプロトコル",
      "zh-Hans": "自订协议"
    },
    "kinio_channel.protocol.enum.halow": {
      "en": "HaLow",
      "ja": "HaLow",
      "zh-Hans": "HaLow"
    },
    "kinio_channel.protocol.enum.local": {
      "en": "Local",
      "ja": "ローカル",
      "zh-Hans": "本机"
    },
    "kinio_channel.protocol.enum.onvif": {
      "en": "ONVIF",
      "ja": "ONVIF",
      "zh-Hans": "ONVIF"
    },
    "kinio_channel.protocol.enum.photo": {
      "en": "Photo frame",
      "ja": "フォトフレーム",
      "zh-Hans": "相框"
    },
    "kinio_channel.protocol.enum.rtsp": {
      "en": "RTSP",
      "ja": "RTSP",
      "zh-Hans": "RTSP"
    },
    "kinio_channel.protocol.enum.subg": {
      "en": "Sub-GHz",
      "ja": "Sub-GHz",
      "zh-Hans": "Sub-GHz"
    },
    "kinio_channel.protocol.enum.test": {
      "en": "Test",
      "ja": "テスト",
      "zh-Hans": "测试"
    },
    "kinio_channel.reboot": {
      "en": "Restart camera",
      "ja": "カメラを再起動",
      "zh-Hans": "重新启动摄像头"
    },
    "kinio_channel.reboot.confirm": {
      "en": "This camera will restart.",
      "ja": "このカメラが再起動します。",
      "zh-Hans": "这台摄像头会重新启动。"
    },
    "kinio_channel.state": {
      "en": "Status",
      "ja": "状態",
      "zh-Hans": "状态"
    },
    "kinio_channel.state.enum.connecting": {
      "en": "Connecting",
      "ja": "接続中",
      "zh-Hans": "连接中"
    },
    "kinio_channel.state.enum.none": {
      "en": "Not set",
      "ja": "未設定",
      "zh-Hans": "未设置"
    },
    "kinio_channel.state.enum.offline": {
      "en": "Offline",
      "ja": "オフライン",
      "zh-Hans": "离线"
    },
    "kinio_channel.state.enum.online": {
      "en": "Online",
      "ja": "オンライン",
      "zh-Hans": "在线"
    },
    "kinio_channel.sub_bitrate": {
      "en": "Sub stream bitrate",
      "ja": "サブストリームのビットレート",
      "zh-Hans": "次串流比特率"
    },
    "kinio_channel.sub_url": {
      "en": "Sub stream path",
      "ja": "サブストリームのパス",
      "zh-Hans": "次串流路径"
    },
    "kinio_channel.test": {
      "en": "Test connection",
      "ja": "接続テスト",
      "zh-Hans": "测试连接"
    },
    "kinio_channel.transport": {
      "en": "Transport",
      "ja": "転送方式",
      "zh-Hans": "传输方式"
    },
    "kinio_channel.transport.enum.tcp": {
      "en": "TCP",
      "ja": "TCP",
      "zh-Hans": "TCP"
    },
    "kinio_channel.transport.enum.udp": {
      "en": "UDP",
      "ja": "UDP",
      "zh-Hans": "UDP"
    },
    "kinio_channel.upgrade": {
      "en": "Update camera firmware",
      "ja": "カメラのファームウェアを更新",
      "zh-Hans": "升级摄像头固件"
    },
    "kinio_channel.user": {
      "en": "Username",
      "ja": "ユーザー名",
      "zh-Hans": "帐号"
    },
    "kinio_channel.width": {
      "en": "Width",
      "ja": "幅",
      "zh-Hans": "宽度"
    },
    "kinio_doorbell.auto_reply": {
      "en": "When no one answers",
      "ja": "応答がないとき",
      "zh-Hans": "没人接时"
    },
    "kinio_doorbell.auto_reply.enum.ai": {
      "en": "AI answers",
      "ja": "AI が応答",
      "zh-Hans": "AI 代答"
    },
    "kinio_doorbell.auto_reply.enum.clip": {
      "en": "Play a recorded reply",
      "ja": "録音済みの応答を再生",
      "zh-Hans": "播放预录回复"
    },
    "kinio_doorbell.auto_reply.enum.off": {
      "en": "Off",
      "ja": "オフ",
      "zh-Hans": "关闭"
    },
    "kinio_doorbell.auto_reply.help": {
      "en": "If the doorbell rings for a while and no one answers, it automatically says something to the visitor.",
      "ja": "ドアベルが鳴ってしばらく応答がないと、訪問者に自動でひと言伝えます。",
      "zh-Hans": "门铃响了一段时间没人接，就自动对访客说一句话"
    },
    "kinio_doorbell.auto_reply_after_seconds": {
      "en": "Wait for",
      "ja": "待ち時間",
      "zh-Hans": "等多久"
    },
    "kinio_doorbell.auto_reply_after_seconds.preset.10": {
      "en": "10 seconds",
      "ja": "10 秒",
      "zh-Hans": "10 秒"
    },
    "kinio_doorbell.auto_reply_after_seconds.preset.15": {
      "en": "15 seconds",
      "ja": "15 秒",
      "zh-Hans": "15 秒"
    },
    "kinio_doorbell.auto_reply_after_seconds.preset.20": {
      "en": "20 seconds (recommended)",
      "ja": "20 秒（推奨）",
      "zh-Hans": "20 秒（建议）"
    },
    "kinio_doorbell.auto_reply_after_seconds.preset.30": {
      "en": "30 seconds",
      "ja": "30 秒",
      "zh-Hans": "30 秒"
    },
    "kinio_doorbell.auto_reply_after_seconds.preset.45": {
      "en": "45 seconds",
      "ja": "45 秒",
      "zh-Hans": "45 秒"
    },
    "kinio_doorbell.chime_time_seconds": {
      "en": "Ring duration",
      "ja": "鳴動時間",
      "zh-Hans": "响铃时长"
    },
    "kinio_doorbell.chime_type": {
      "en": "Chime type",
      "ja": "室内チャイムの種類",
      "zh-Hans": "室内铃类型"
    },
    "kinio_doorbell.chime_type.enum.electronic": {
      "en": "Digital",
      "ja": "電子式",
      "zh-Hans": "电子式"
    },
    "kinio_doorbell.chime_type.enum.mechanical": {
      "en": "Mechanical",
      "ja": "機械式",
      "zh-Hans": "机械式"
    },
    "kinio_doorbell.ring_tone": {
      "en": "Doorbell ringtone",
      "ja": "ドアベルの呼び出し音",
      "zh-Hans": "门铃铃声"
    },
    "kinio_doorbell.ring_tone.enum.chime": {
      "en": "Chime",
      "ja": "チャイム",
      "zh-Hans": "钟声"
    },
    "kinio_doorbell.ring_tone.enum.dingdong": {
      "en": "Ding-dong",
      "ja": "ピンポン",
      "zh-Hans": "叮咚"
    },
    "kinio_doorbell.ring_tone.enum.melody": {
      "en": "Melody",
      "ja": "メロディ",
      "zh-Hans": "旋律"
    },
    "kinio_doorbell.ring_volume": {
      "en": "Doorbell ring volume",
      "ja": "ドアベルの呼び出し音量",
      "zh-Hans": "门铃铃声音量"
    },
    "kinio_firmware.channel": {
      "en": "Update channel",
      "ja": "アップデートチャンネル",
      "zh-Hans": "更新通道"
    },
    "kinio_firmware.channel.enum.beta": {
      "en": "Beta",
      "ja": "ベータ版",
      "zh-Hans": "抢先版"
    },
    "kinio_firmware.channel.enum.dev": {
      "en": "Development",
      "ja": "開発版",
      "zh-Hans": "开发版"
    },
    "kinio_firmware.channel.enum.stable": {
      "en": "Stable",
      "ja": "安定版",
      "zh-Hans": "正式版"
    },
    "kinio_firmware.security_floor": {
      "en": "Security floor",
      "ja": "セキュリティ下限",
      "zh-Hans": "安全下限"
    },
    "kinio_firmware.security_floor.help": {
      "en": "The device's current security floor (only goes up; rescue won't install anything older). The platform raises it with the security_floor command per model; not shown in the app.",
      "ja": "デバイスの現在のセキュリティ下限（上がるだけで下がりません。レスキューはこれより古いバージョンを受け付けません）。プラットフォームが機種ごとの下限に合わせて security_floor コマンドで引き上げます。アプリには表示しません。",
      "zh-Hans": "设备目前的安全下限（只增不减；救援不收低于它的版本）。平台依机种下限推 security_floor 命令往上调，App 不显示"
    },
    "kinio_floodlight.color_image_ctrl": {
      "en": "Switch to color video when lit",
      "ja": "点灯中はカラー映像にする",
      "zh-Hans": "亮灯时改彩色画面"
    },
    "kinio_floodlight.light_on_duration_seconds": {
      "en": "Light duration",
      "ja": "点灯時間",
      "zh-Hans": "亮灯多久"
    },
    "kinio_floodlight.light_on_duration_seconds.preset.180": {
      "en": "3 minutes",
      "ja": "3 分",
      "zh-Hans": "3 分钟"
    },
    "kinio_floodlight.light_on_duration_seconds.preset.30": {
      "en": "30 seconds",
      "ja": "30 秒",
      "zh-Hans": "30 秒"
    },
    "kinio_floodlight.light_on_duration_seconds.preset.300": {
      "en": "5 minutes",
      "ja": "5 分",
      "zh-Hans": "5 分钟"
    },
    "kinio_floodlight.light_on_duration_seconds.preset.60": {
      "en": "1 minute (recommended)",
      "ja": "1 分（推奨）",
      "zh-Hans": "1 分钟（建议）"
    },
    "kinio_floodlight.light_warn": {
      "en": "Light up on activity",
      "ja": "動きを検知したら点灯",
      "zh-Hans": "侦测到动静时亮灯"
    },
    "kinio_floodlight.lux_threshold": {
      "en": "Darkness level",
      "ja": "暗さの判定",
      "zh-Hans": "判断天黑"
    },
    "kinio_floodlight.lux_threshold.enum.dusk": {
      "en": "At dusk (recommended)",
      "ja": "薄暗くなったら（推奨）",
      "zh-Hans": "天色转暗就算（建议）"
    },
    "kinio_floodlight.lux_threshold.enum.night": {
      "en": "Only when fully dark",
      "ja": "真っ暗になったら",
      "zh-Hans": "全黑才算"
    },
    "kinio_floodlight.mode": {
      "en": "Light mode",
      "ja": "点灯方式",
      "zh-Hans": "灯光方式"
    },
    "kinio_floodlight.mode.enum.strobe": {
      "en": "Strobe",
      "ja": "点滅",
      "zh-Hans": "闪烁"
    },
    "kinio_floodlight.mode.enum.warning": {
      "en": "Steady (recommended)",
      "ja": "点灯（推奨）",
      "zh-Hans": "恒亮（建议）"
    },
    "kinio_floodlight.red_blue_enabled": {
      "en": "Red and blue warning lights",
      "ja": "赤青の警告灯",
      "zh-Hans": "红蓝警示灯"
    },
    "kinio_floodlight.schedule": {
      "en": "Active hours",
      "ja": "有効な時間帯",
      "zh-Hans": "生效时段"
    },
    "kinio_floodlight.sensitivity": {
      "en": "Light trigger sensitivity",
      "ja": "点灯の検知感度",
      "zh-Hans": "亮灯触发灵敏度"
    },
    "kinio_floodlight.stop": {
      "en": "Turn off",
      "ja": "消灯",
      "zh-Hans": "熄灭"
    },
    "kinio_floodlight.strobe_frequency": {
      "en": "Strobe speed",
      "ja": "点滅の速さ",
      "zh-Hans": "闪烁速度"
    },
    "kinio_floodlight.strobe_frequency.enum.high": {
      "en": "Fast",
      "ja": "速い",
      "zh-Hans": "快"
    },
    "kinio_floodlight.strobe_frequency.enum.low": {
      "en": "Slow",
      "ja": "遅い",
      "zh-Hans": "慢"
    },
    "kinio_floodlight.strobe_frequency.enum.mid": {
      "en": "Medium",
      "ja": "中",
      "zh-Hans": "中"
    },
    "kinio_floodlight.trigger": {
      "en": "Turn on",
      "ja": "点灯",
      "zh-Hans": "点亮"
    },
    "kinio_floodlight.trigger_condition": {
      "en": "Lighting hours",
      "ja": "点灯する時間帯",
      "zh-Hans": "亮灯时段"
    },
    "kinio_floodlight.trigger_condition.enum.day_and_night": {
      "en": "All day",
      "ja": "終日",
      "zh-Hans": "全天"
    },
    "kinio_floodlight.trigger_condition.enum.night_only": {
      "en": "Only at night (recommended)",
      "ja": "夜間のみ（推奨）",
      "zh-Hans": "只在晚上（建议）"
    },
    "kinio_floodlight.high_brightness": {
      "en": "Light brightness",
      "ja": "点灯時の明るさ",
      "zh-Hans": "亮灯亮度"
    },
    "kinio_floodlight.high_brightness.help": {
      "en": "Brightness when you turn the light on or it lights up on motion",
      "ja": "手動で点灯したときと、動きを検知して点灯したときの明るさ",
      "zh-Hans": "手动点亮与侦测到动静亮灯时的亮度"
    },
    "kinio_floodlight.low_brightness": {
      "en": "Night vision light brightness",
      "ja": "ナイトビジョン常時点灯の明るさ",
      "zh-Hans": "夜视常亮亮度"
    },
    "kinio_floodlight.low_brightness.help": {
      "en": "Brightness of the white light used for night vision",
      "ja": "夜間に白色ライトをナイトビジョンに使うときの明るさ",
      "zh-Hans": "晚上用白光当夜视补光时的亮度"
    },
    "kinio_halow.bandwidth_mhz": {
      "en": "Bandwidth",
      "ja": "帯域幅",
      "zh-Hans": "带宽"
    },
    "kinio_halow.bandwidth_mhz.enum.bw1": {
      "en": "1 MHz",
      "ja": "1 MHz",
      "zh-Hans": "1 MHz"
    },
    "kinio_halow.bandwidth_mhz.enum.bw2": {
      "en": "2 MHz",
      "ja": "2 MHz",
      "zh-Hans": "2 MHz"
    },
    "kinio_halow.bandwidth_mhz.enum.bw4": {
      "en": "4 MHz",
      "ja": "4 MHz",
      "zh-Hans": "4 MHz"
    },
    "kinio_halow.bandwidth_mhz.enum.bw8": {
      "en": "8 MHz",
      "ja": "8 MHz",
      "zh-Hans": "8 MHz"
    },
    "kinio_halow.channel": {
      "en": "Channel",
      "ja": "チャンネル",
      "zh-Hans": "频道"
    },
    "kinio_halow.enabled": {
      "en": "HaLow",
      "ja": "HaLow",
      "zh-Hans": "HaLow"
    },
    "kinio_halow.pairing": {
      "en": "Pairing",
      "ja": "ペアリング中",
      "zh-Hans": "配对中"
    },
    "kinio_halow.ssid": {
      "en": "Network name",
      "ja": "ネットワーク名",
      "zh-Hans": "网络名称"
    },
    "kinio_image.ai_overlay": {
      "en": "Show detection boxes on video",
      "ja": "映像に検知枠を表示",
      "zh-Hans": "画面标示侦测框"
    },
    "kinio_image.flicker_hz": {
      "en": "Anti-flicker",
      "ja": "フリッカー防止",
      "zh-Hans": "防闪烁"
    },
    "kinio_image.flicker_hz.enum.hz50": {
      "en": "50 Hz",
      "ja": "50 Hz",
      "zh-Hans": "50 Hz"
    },
    "kinio_image.flicker_hz.enum.hz60": {
      "en": "60 Hz",
      "ja": "60 Hz",
      "zh-Hans": "60 Hz"
    },
    "kinio_image.flicker_hz.help": {
      "en": "Choose your local mains frequency so the video doesn't show horizontal bands",
      "ja": "お住まいの地域の電源周波数を選ぶと、映像に横縞が出ません",
      "zh-Hans": "照所在地的市电频率选，画面才不会出现横纹"
    },
    "kinio_image.flip": {
      "en": "Flip vertically",
      "ja": "上下反転",
      "zh-Hans": "上下翻转"
    },
    "kinio_image.mirror": {
      "en": "Mirror horizontally",
      "ja": "左右反転",
      "zh-Hans": "左右镜像"
    },
    "kinio_image.privacy_masks": {
      "en": "Privacy masks",
      "ja": "プライバシーマスク",
      "zh-Hans": "隐私遮罩"
    },
    "kinio_image.privacy_masks.help": {
      "en": "Masks are blacked out on the device before encoding. They are hidden in live view, recordings and snapshots, and cannot be removed later.",
      "ja": "マスクはデバイス側でエンコード前に黒く塗りつぶされます。ライブ、録画、スナップショットのいずれにも映らず、後から解除することはできません。",
      "zh-Hans": "遮罩在设备端编码前涂黑，直播、录像、快照都看不到，之后也无法解除"
    },
    "kinio_image.privacy_mode": {
      "en": "Privacy",
      "ja": "プライバシー",
      "zh-Hans": "隐私"
    },
    "kinio_image.privacy_mode.help": {
      "en": "Stops capturing video and audio. Movable lenses turn toward the body and the status light turns red.",
      "ja": "映像と音声の取得を止めます。動かせるレンズは本体側を向き、状態ランプが赤く点灯します。",
      "zh-Hans": "停止采集影像与声音，可转动的镜头会转向机身，状态灯亮红灯"
    },
    "kinio_image.sleep_mode": {
      "en": "Sleep",
      "ja": "スリープ",
      "zh-Hans": "休眠"
    },
    "kinio_image.sleep_mode.confirm": {
      "en": "While sleeping, the device won't record or send notifications.",
      "ja": "スリープ中は録画も通知もしません。",
      "zh-Hans": "休眠期间不会录像，也不会发送通知。"
    },
    "kinio_image.sleep_mode.help": {
      "en": "No recording or notifications; you can still watch when you open live view",
      "ja": "録画も通知もしません。ライブ映像を開けば見ることはできます",
      "zh-Hans": "不录像、不发送通知；你主动打开即时影像时仍然看得到"
    },
    "kinio_image.watermark": {
      "en": "Time stamp",
      "ja": "時刻表示",
      "zh-Hans": "时间浮水印"
    },
    "kinio_journey.active_scene": {
      "en": "Current scene",
      "ja": "現在のシーン",
      "zh-Hans": "目前场景"
    },
    "kinio_journey.active_scene.enum.away": {
      "en": "Away",
      "ja": "外出",
      "zh-Hans": "离家"
    },
    "kinio_journey.active_scene.enum.night": {
      "en": "Night",
      "ja": "夜間",
      "zh-Hans": "夜间"
    },
    "kinio_journey.active_scene.enum.none": {
      "en": "None",
      "ja": "なし",
      "zh-Hans": "无"
    },
    "kinio_journey.active_scene.enum.sleep": {
      "en": "Sleep",
      "ja": "睡眠",
      "zh-Hans": "睡眠"
    },
    "kinio_journey.active_scene.enum.wake": {
      "en": "Wake up",
      "ja": "起床",
      "zh-Hans": "起床"
    },
    "kinio_journey.stop_scene": {
      "en": "Stop scene",
      "ja": "シーンを停止",
      "zh-Hans": "停止场景"
    },
    "kinio_lens.record_secondary": {
      "en": "Also record the second lens",
      "ja": "サブレンズも録画",
      "zh-Hans": "副镜头也录像"
    },
    "kinio_lens.record_secondary.confirm": {
      "en": "The second lens will also record, with the same recording mode and retention days as the main lens. Video may be less smooth.",
      "ja": "サブレンズも録画します。録画方法と保存日数はメインレンズと同じです。映像の滑らかさが下がることがあります。",
      "zh-Hans": "副镜头也会录像，录像方式与保存天数跟主镜头一样，可能降低画面流畅度。"
    },
    "kinio_local_services.credential_set": {
      "en": "Admin password set",
      "ja": "管理パスワード設定済み",
      "zh-Hans": "已设置管理密码"
    },
    "kinio_local_services.onvif_enabled": {
      "en": "ONVIF",
      "ja": "ONVIF",
      "zh-Hans": "ONVIF"
    },
    "kinio_local_services.onvif_enabled.help": {
      "en": "Turning this on also turns on RTSP",
      "ja": "オンにすると RTSP もオンになります",
      "zh-Hans": "打开后 RTSP 也会一起开"
    },
    "kinio_local_services.onvif_profiles": {
      "en": "ONVIF Profile",
      "ja": "ONVIF プロファイル",
      "zh-Hans": "ONVIF Profile"
    },
    "kinio_local_services.rtsp_enabled": {
      "en": "RTSP",
      "ja": "RTSP",
      "zh-Hans": "RTSP"
    },
    "kinio_local_services.set_admin_credential": {
      "en": "Set admin password",
      "ja": "管理パスワードを設定",
      "zh-Hans": "设置管理密码"
    },
    "kinio_local_services.set_admin_credential.help": {
      "en": "ONVIF, RTSP and the local web page share these credentials",
      "ja": "ONVIF / RTSP / ローカル Web で共通のアカウントです",
      "zh-Hans": "ONVIF / RTSP / 本机网页共用这组帐密"
    },
    "kinio_local_services.web_enabled": {
      "en": "Local web admin",
      "ja": "ローカル Web 管理",
      "zh-Hans": "本机网页管理"
    },
    "kinio_mic.adaptive_enabled": {
      "en": "Adaptive this session",
      "ja": "今回の自動調整",
      "zh-Hans": "本次自适应"
    },
    "kinio_mic.attached": {
      "en": "Microphone",
      "ja": "マイク",
      "zh-Hans": "麦克风"
    },
    "kinio_mic.fault": {
      "en": "Microphone status",
      "ja": "マイクの状態",
      "zh-Hans": "麦克风状态"
    },
    "kinio_mic.fault.enum.blocked": {
      "en": "Blocked",
      "ja": "ふさがれています",
      "zh-Hans": "被遮住"
    },
    "kinio_mic.fault.enum.contact": {
      "en": "Loose connection",
      "ja": "接触不良",
      "zh-Hans": "接触不良"
    },
    "kinio_mic.fault.enum.hw": {
      "en": "Hardware fault",
      "ja": "ハードウェア故障",
      "zh-Hans": "硬件故障"
    },
    "kinio_mic.fault.enum.none": {
      "en": "Normal",
      "ja": "正常",
      "zh-Hans": "正常"
    },
    "kinio_motion.alarm_interval_seconds": {
      "en": "Notification interval",
      "ja": "通知の間隔",
      "zh-Hans": "通知间隔"
    },
    "kinio_motion.alarm_interval_seconds.help": {
      "en": "You're notified only once per activity within this time",
      "ja": "同じ動きはこの時間内に 1 回だけ通知します",
      "zh-Hans": "同一次动静在这段时间内只通知一次"
    },
    "kinio_motion.alarm_interval_seconds.preset.180": {
      "en": "3 minutes (recommended)",
      "ja": "3 分（推奨）",
      "zh-Hans": "3 分钟（建议）"
    },
    "kinio_motion.alarm_interval_seconds.preset.1800": {
      "en": "30 minutes",
      "ja": "30 分",
      "zh-Hans": "30 分钟"
    },
    "kinio_motion.alarm_interval_seconds.preset.300": {
      "en": "5 minutes",
      "ja": "5 分",
      "zh-Hans": "5 分钟"
    },
    "kinio_motion.alarm_interval_seconds.preset.600": {
      "en": "10 minutes",
      "ja": "10 分",
      "zh-Hans": "10 分钟"
    },
    "kinio_motion.enabled": {
      "en": "Motion detection",
      "ja": "動体検知",
      "zh-Hans": "移动侦测"
    },
    "kinio_motion.human_filter": {
      "en": "Notify only when a person is detected",
      "ja": "人を検知したときだけ通知",
      "zh-Hans": "只在侦测到人时通知"
    },
    "kinio_motion.pir1_enabled": {
      "en": "Motion sensor 1",
      "ja": "人感センサー 1",
      "zh-Hans": "移动传感器 1"
    },
    "kinio_motion.pir2_enabled": {
      "en": "Motion sensor 2",
      "ja": "人感センサー 2",
      "zh-Hans": "移动传感器 2"
    },
    "kinio_motion.pir3_enabled": {
      "en": "Motion sensor 3",
      "ja": "人感センサー 3",
      "zh-Hans": "移动传感器 3"
    },
    "kinio_motion.pir_sensitivity": {
      "en": "PIR sensitivity",
      "ja": "PIR 感度",
      "zh-Hans": "PIR 灵敏度"
    },
    "kinio_motion.pir_sensitivity.enum.high": {
      "en": "High",
      "ja": "高",
      "zh-Hans": "高"
    },
    "kinio_motion.pir_sensitivity.enum.low": {
      "en": "Low",
      "ja": "低",
      "zh-Hans": "低"
    },
    "kinio_motion.pir_sensitivity.enum.mid": {
      "en": "Medium (recommended)",
      "ja": "中（推奨）",
      "zh-Hans": "中（建议）"
    },
    "kinio_motion.schedule": {
      "en": "Active hours",
      "ja": "有効な時間帯",
      "zh-Hans": "生效时段"
    },
    "kinio_motion.sensitivity": {
      "en": "Sensitivity",
      "ja": "感度",
      "zh-Hans": "灵敏度"
    },
    "kinio_motion.sensitivity.enum.high": {
      "en": "High",
      "ja": "高",
      "zh-Hans": "高"
    },
    "kinio_motion.sensitivity.enum.low": {
      "en": "Low",
      "ja": "低",
      "zh-Hans": "低"
    },
    "kinio_motion.sensitivity.enum.mid": {
      "en": "Medium (recommended)",
      "ja": "中（推奨）",
      "zh-Hans": "中（建议）"
    },
    "kinio_motion.zone_grid": {
      "en": "Detection zones",
      "ja": "検知エリア",
      "zh-Hans": "侦测区域"
    },
    "kinio_motion.zone_grid.help": {
      "en": "Grid used by NVR / Station channels (a device declares either zones or zone_grid, not both)",
      "ja": "NVR / Station のチャンネル用グリッド（デバイスは zones か zone_grid のどちらか一方だけを宣言します）",
      "zh-Hans": "NVR / Station 通道用网格（设备只会声明 zones 或 zone_grid 其中一个）"
    },
    "kinio_motion.zones": {
      "en": "Detection zones",
      "ja": "検知エリア",
      "zh-Hans": "侦测区域"
    },
    "kinio_mycam.audio_detect": {
      "en": "Sound detection",
      "ja": "音検知",
      "zh-Hans": "声音侦测"
    },
    "kinio_mycam.audio_detect.help": {
      "en": "Detected on this phone only; no audio is saved",
      "ja": "このスマートフォン上でのみ判定し、音声は保存しません",
      "zh-Hans": "只在这台手机上判断，不存声音"
    },
    "kinio_mycam.audio_record": {
      "en": "Audio recording",
      "ja": "録音",
      "zh-Hans": "录音"
    },
    "kinio_mycam.audio_record.confirm": {
      "en": "Recording other people's conversations may be illegal in some places. Turn on audio recording?",
      "ja": "他人の会話を録音することは、地域によっては違法となる場合があります。録音をオンにしますか？",
      "zh-Hans": "录下别人的对话在部分地区可能违法。确定要打开录音？"
    },
    "kinio_mycam.home_mode": {
      "en": "Pause while owner is home",
      "ja": "在宅中は一時停止",
      "zh-Hans": "主人在家时暂停"
    },
    "kinio_mycam.home_mode.enum.off": {
      "en": "Off",
      "ja": "オフ",
      "zh-Hans": "关闭"
    },
    "kinio_mycam.home_mode.enum.when_owner_home": {
      "en": "Pause while owner is home",
      "ja": "在宅中は一時停止",
      "zh-Hans": "主人在家时暂停"
    },
    "kinio_mycam.lens": {
      "en": "Lens",
      "ja": "レンズ",
      "zh-Hans": "镜头"
    },
    "kinio_mycam.pause_reason": {
      "en": "Pause reason",
      "ja": "一時停止の理由",
      "zh-Hans": "暂停原因"
    },
    "kinio_mycam.pause_reason.enum.app_background": {
      "en": "App in background",
      "ja": "アプリがバックグラウンド",
      "zh-Hans": "App 在背景"
    },
    "kinio_mycam.pause_reason.enum.battery_low": {
      "en": "Low battery",
      "ja": "バッテリー残量低下",
      "zh-Hans": "电量低"
    },
    "kinio_mycam.pause_reason.enum.camera_busy": {
      "en": "Camera in use",
      "ja": "カメラが使用中です",
      "zh-Hans": "摄像头被占用"
    },
    "kinio_mycam.pause_reason.enum.home_mode": {
      "en": "Owner at home",
      "ja": "在宅中",
      "zh-Hans": "主人在家"
    },
    "kinio_mycam.pause_reason.enum.in_pocket": {
      "en": "Phone put away",
      "ja": "スマートフォンがしまわれています",
      "zh-Hans": "手机被收起"
    },
    "kinio_mycam.pause_reason.enum.killed": {
      "en": "App closed",
      "ja": "アプリが終了しました",
      "zh-Hans": "App 被关闭"
    },
    "kinio_mycam.pause_reason.enum.local_network_denied": {
      "en": "Local network permission missing",
      "ja": "ローカルネットワークの権限がありません",
      "zh-Hans": "缺少本地网络权限"
    },
    "kinio_mycam.pause_reason.enum.mic_denied": {
      "en": "Microphone permission missing",
      "ja": "マイクの権限がありません",
      "zh-Hans": "缺少麦克风权限"
    },
    "kinio_mycam.pause_reason.enum.none": {
      "en": "None",
      "ja": "なし",
      "zh-Hans": "无"
    },
    "kinio_mycam.pause_reason.enum.permission": {
      "en": "Camera permission missing",
      "ja": "カメラの権限がありません",
      "zh-Hans": "缺少摄像头权限"
    },
    "kinio_mycam.pause_reason.enum.plan_limit": {
      "en": "Over the plan's device limit",
      "ja": "プランの台数上限を超えています",
      "zh-Hans": "超过方案台数"
    },
    "kinio_mycam.pause_reason.enum.schedule": {
      "en": "Schedule",
      "ja": "スケジュール",
      "zh-Hans": "排程"
    },
    "kinio_mycam.pause_reason.enum.storage_full": {
      "en": "Storage full",
      "ja": "空き容量がありません",
      "zh-Hans": "空间已满"
    },
    "kinio_mycam.pause_reason.enum.thermal": {
      "en": "Overheating",
      "ja": "過熱",
      "zh-Hans": "过热"
    },
    "kinio_mycam.pause_reason.enum.updating": {
      "en": "Updating",
      "ja": "更新中",
      "zh-Hans": "更新中"
    },
    "kinio_mycam.pause_reason.enum.user": {
      "en": "Paused manually",
      "ja": "手動で一時停止",
      "zh-Hans": "手动暂停"
    },
    "kinio_mycam.purpose": {
      "en": "Purpose",
      "ja": "用途",
      "zh-Hans": "用途"
    },
    "kinio_mycam.purpose.enum.baby": {
      "en": "Baby",
      "ja": "赤ちゃん",
      "zh-Hans": "宝宝"
    },
    "kinio_mycam.purpose.enum.custom": {
      "en": "Custom",
      "ja": "カスタム",
      "zh-Hans": "自订"
    },
    "kinio_mycam.purpose.enum.home": {
      "en": "Home watch",
      "ja": "見守り",
      "zh-Hans": "看家"
    },
    "kinio_mycam.purpose.enum.pet": {
      "en": "Pet",
      "ja": "ペット",
      "zh-Hans": "宠物"
    },
    "kinio_mycam.purpose.enum.shop": {
      "en": "Shop",
      "ja": "店舗",
      "zh-Hans": "店面"
    },
    "kinio_mycam.screen": {
      "en": "Screen",
      "ja": "画面",
      "zh-Hans": "屏幕"
    },
    "kinio_mycam.screen.enum.clock": {
      "en": "Clock",
      "ja": "時計",
      "zh-Hans": "时钟"
    },
    "kinio_mycam.screen.enum.dim": {
      "en": "Dark",
      "ja": "黒画面",
      "zh-Hans": "全黑"
    },
    "kinio_mycam.screen.enum.preview": {
      "en": "Show video",
      "ja": "映像を表示",
      "zh-Hans": "显示画面"
    },
    "kinio_mycam.state": {
      "en": "Status",
      "ja": "状態",
      "zh-Hans": "状态"
    },
    "kinio_mycam.state.enum.active": {
      "en": "Watching",
      "ja": "見守り中",
      "zh-Hans": "看家中"
    },
    "kinio_mycam.state.enum.paused": {
      "en": "Paused",
      "ja": "一時停止中",
      "zh-Hans": "已暂停"
    },
    "kinio_mycam.state.enum.stopped": {
      "en": "Stopped",
      "ja": "停止中",
      "zh-Hans": "已停用"
    },
    "kinio_mycam.thermal": {
      "en": "Temperature",
      "ja": "温度",
      "zh-Hans": "温度"
    },
    "kinio_mycam.thermal.enum.critical": {
      "en": "Critical",
      "ja": "危険",
      "zh-Hans": "危险"
    },
    "kinio_mycam.thermal.enum.fair": {
      "en": "Warm",
      "ja": "やや高温",
      "zh-Hans": "偏热"
    },
    "kinio_mycam.thermal.enum.nominal": {
      "en": "Normal",
      "ja": "正常",
      "zh-Hans": "正常"
    },
    "kinio_mycam.thermal.enum.serious": {
      "en": "Overheating",
      "ja": "過熱",
      "zh-Hans": "过热"
    },
    "kinio_node.site_name": {
      "en": "Site settings",
      "ja": "拠点設定",
      "zh-Hans": "场所设置"
    },
    "kinio_node.ttl_baud": {
      "en": "UART (TTL) baud rate",
      "ja": "UART（TTL）ボーレート",
      "zh-Hans": "UART（TTL）速率"
    },
    "kinio_node.ttl_dut": {
      "en": "Device on UART (TTL)",
      "ja": "UART（TTL）に接続中の機器",
      "zh-Hans": "UART（TTL）连接的设备"
    },
    "kinio_node.ttl_dut.help": {
      "en": "The name the person who wired it set on the node (fleet control ttl_config dut, or node console fac_set ttl_dut)",
      "ja": "配線した人がノードに設定した名前（デバイス群制御 ttl_config の dut、またはノード console の fac_set ttl_dut）",
      "zh-Hans": "接线的人在节点设置的名称（设备群控制 ttl_config 的 dut，或节点 console fac_set ttl_dut）"
    },
    "kinio_node.ttl_enabled": {
      "en": "UART (TTL) bridge",
      "ja": "UART（TTL）ブリッジ",
      "zh-Hans": "UART（TTL）桥接"
    },
    "kinio_node.user_wifi_ssid": {
      "en": "User Wi-Fi",
      "ja": "ユーザーの Wi-Fi",
      "zh-Hans": "用户 Wi-Fi"
    },
    "kinio_node.wifi_source": {
      "en": "In use",
      "ja": "使用中",
      "zh-Hans": "目前使用"
    },
    "kinio_node.wifi_source.enum.none": {
      "en": "None",
      "ja": "なし",
      "zh-Hans": "无"
    },
    "kinio_node.wifi_source.enum.site": {
      "en": "Site settings",
      "ja": "拠点設定",
      "zh-Hans": "场所设置"
    },
    "kinio_node.wifi_source.enum.user": {
      "en": "User Wi-Fi",
      "ja": "ユーザーの Wi-Fi",
      "zh-Hans": "用户 Wi-Fi"
    },
    "kinio_object_recognition.confidence_threshold": {
      "en": "Confidence threshold",
      "ja": "信頼度のしきい値",
      "zh-Hans": "信心门槛"
    },
    "kinio_object_recognition.enabled": {
      "en": "AI object recognition",
      "ja": "AI 物体認識",
      "zh-Hans": "AI 物体辨识"
    },
    "kinio_object_recognition.pet_enabled": {
      "en": "Pet detection",
      "ja": "ペット検知",
      "zh-Hans": "宠物侦测"
    },
    "kinio_onvif.profiles": {
      "en": "Profile",
      "ja": "プロファイル",
      "zh-Hans": "Profile"
    },
    "kinio_onvif.templates": {
      "en": "Custom protocol templates",
      "ja": "カスタムプロトコルのテンプレート",
      "zh-Hans": "自订协议样板"
    },
    "kinio_power.battery_lock": {
      "en": "Low battery protection",
      "ja": "バッテリー低下保護",
      "zh-Hans": "低电量保护"
    },
    "kinio_power.check_in_interval_seconds": {
      "en": "Sync interval",
      "ja": "同期間隔",
      "zh-Hans": "同步间隔"
    },
    "kinio_power.check_in_interval_seconds.preset.21600": {
      "en": "6 hours",
      "ja": "6 時間",
      "zh-Hans": "6 小时"
    },
    "kinio_power.check_in_interval_seconds.preset.3600": {
      "en": "1 hour (recommended)",
      "ja": "1 時間（推奨）",
      "zh-Hans": "1 小时（建议）"
    },
    "kinio_power.check_in_interval_seconds.preset.86400": {
      "en": "1 day",
      "ja": "1 日",
      "zh-Hans": "1 天"
    },
    "kinio_power.check_in_interval_seconds.preset.900": {
      "en": "15 minutes",
      "ja": "15 分",
      "zh-Hans": "15 分钟"
    },
    "kinio_power.enter_low_power": {
      "en": "Enter low power",
      "ja": "低電力モードに入る",
      "zh-Hans": "进入低功耗"
    },
    "kinio_power.low_battery_threshold": {
      "en": "Low battery alert",
      "ja": "バッテリー低下の通知",
      "zh-Hans": "低电量提醒"
    },
    "kinio_power.low_battery_threshold.preset.10": {
      "en": "10%",
      "ja": "10%",
      "zh-Hans": "10%"
    },
    "kinio_power.low_battery_threshold.preset.15": {
      "en": "15%",
      "ja": "15%",
      "zh-Hans": "15%"
    },
    "kinio_power.low_battery_threshold.preset.20": {
      "en": "20% (recommended)",
      "ja": "20%（推奨）",
      "zh-Hans": "20%（建议）"
    },
    "kinio_power.low_battery_threshold.preset.30": {
      "en": "30%",
      "ja": "30%",
      "zh-Hans": "30%"
    },
    "kinio_power.next_check_in_at": {
      "en": "Next sync",
      "ja": "次回の同期",
      "zh-Hans": "下次同步"
    },
    "kinio_power.power_mode": {
      "en": "Power mode",
      "ja": "電源モード",
      "zh-Hans": "电源模式"
    },
    "kinio_power.power_mode.enum.balanced": {
      "en": "Balanced (recommended)",
      "ja": "バランス（推奨）",
      "zh-Hans": "平衡（建议）"
    },
    "kinio_power.power_mode.enum.low_power": {
      "en": "Longest battery",
      "ja": "省電力優先",
      "zh-Hans": "省电优先"
    },
    "kinio_power.power_mode.enum.performance": {
      "en": "Best quality",
      "ja": "画質優先",
      "zh-Hans": "画质优先"
    },
    "kinio_power.wakeup_sources": {
      "en": "Wake-up sources",
      "ja": "復帰のきっかけ",
      "zh-Hans": "唤醒来源"
    },
    "kinio_ptz.calibrate": {
      "en": "Calibrate",
      "ja": "キャリブレーション",
      "zh-Hans": "校正"
    },
    "kinio_ptz.calibrate.help": {
      "en": "Use this when the direction drifts or presets are off",
      "ja": "向きがずれたり、プリセット位置が合わないときに使います",
      "zh-Hans": "方向偏掉或预置点不准时使用"
    },
    "kinio_ptz.goto_preset": {
      "en": "Go to preset",
      "ja": "プリセット位置へ移動",
      "zh-Hans": "移至预置点"
    },
    "kinio_ptz.object_tracking": {
      "en": "Auto tracking",
      "ja": "自動追尾",
      "zh-Hans": "自动追踪"
    },
    "kinio_ptz.guard_enabled": {
      "en": "Guard position",
      "ja": "ガード位置",
      "zh-Hans": "看守位"
    },
    "kinio_ptz.guard_enabled.help": {
      "en": "When the camera has been left pointing elsewhere for a while, it turns back to the guard preset. It also starts there after a restart.",
      "ja": "しばらく別の方向で止まったままだと、ガード位置のプリセットへ自動で戻ります。再起動後もその位置から始まります。",
      "zh-Hans": "云台停在别处一段时间没动，就自动转回看守的预置点；开机也会停在那里"
    },
    "kinio_ptz.guard_idle_seconds": {
      "en": "Return after idle for",
      "ja": "戻るまでの待ち時間",
      "zh-Hans": "多久没动就回去"
    },
    "kinio_ptz.guard_idle_seconds.preset.30": {
      "en": "30 seconds",
      "ja": "30 秒",
      "zh-Hans": "30 秒"
    },
    "kinio_ptz.guard_idle_seconds.preset.60": {
      "en": "1 minute (recommended)",
      "ja": "1 分（推奨）",
      "zh-Hans": "1 分钟（建议）"
    },
    "kinio_ptz.guard_idle_seconds.preset.120": {
      "en": "2 minutes",
      "ja": "2 分",
      "zh-Hans": "2 分钟"
    },
    "kinio_ptz.guard_idle_seconds.preset.300": {
      "en": "5 minutes",
      "ja": "5 分",
      "zh-Hans": "5 分钟"
    },
    "kinio_ptz.guard_idle_seconds.preset.600": {
      "en": "10 minutes",
      "ja": "10 分",
      "zh-Hans": "10 分钟"
    },
    "kinio_ptz.patrol_dwell_seconds": {
      "en": "Stay at each preset for",
      "ja": "各プリセットでの停止時間",
      "zh-Hans": "每个点停多久"
    },
    "kinio_ptz.patrol_dwell_seconds.preset.10": {
      "en": "10 seconds",
      "ja": "10 秒",
      "zh-Hans": "10 秒"
    },
    "kinio_ptz.patrol_dwell_seconds.preset.120": {
      "en": "2 minutes",
      "ja": "2 分",
      "zh-Hans": "2 分钟"
    },
    "kinio_ptz.patrol_dwell_seconds.preset.15": {
      "en": "15 seconds (recommended)",
      "ja": "15 秒（推奨）",
      "zh-Hans": "15 秒（建议）"
    },
    "kinio_ptz.patrol_dwell_seconds.preset.30": {
      "en": "30 seconds",
      "ja": "30 秒",
      "zh-Hans": "30 秒"
    },
    "kinio_ptz.patrol_dwell_seconds.preset.5": {
      "en": "5 seconds",
      "ja": "5 秒",
      "zh-Hans": "5 秒"
    },
    "kinio_ptz.patrol_dwell_seconds.preset.60": {
      "en": "1 minute",
      "ja": "1 分",
      "zh-Hans": "1 分钟"
    },
    "kinio_ptz.patrol_enabled": {
      "en": "Patrol",
      "ja": "巡回",
      "zh-Hans": "巡航"
    },
    "kinio_ptz.patrol_enabled.help": {
      "en": "The camera turns through the presets in order, even when the app is closed. Needs at least two presets.",
      "ja": "プリセットを順番に巡回します。アプリを閉じても動き続けます。プリセットが 2 つ以上必要です。",
      "zh-Hans": "云台依预置点顺序轮流转，App 关掉也照跑；至少要两个预置点"
    },
    "kinio_recording.detection_schedule": {
      "en": "Detection recording hours",
      "ja": "検知録画の時間帯",
      "zh-Hans": "侦测录像时段"
    },
    "kinio_recording.event_mask": {
      "en": "Events that trigger recording",
      "ja": "録画を開始するイベント",
      "zh-Hans": "触发录像的事件"
    },
    "kinio_recording.manual_length_seconds": {
      "en": "Manual recording length",
      "ja": "手動録画の長さ",
      "zh-Hans": "手动录像长度"
    },
    "kinio_recording.manual_length_seconds.preset.120": {
      "en": "2 minutes",
      "ja": "2 分",
      "zh-Hans": "2 分钟"
    },
    "kinio_recording.manual_length_seconds.preset.30": {
      "en": "30 seconds",
      "ja": "30 秒",
      "zh-Hans": "30 秒"
    },
    "kinio_recording.manual_length_seconds.preset.300": {
      "en": "5 minutes",
      "ja": "5 分",
      "zh-Hans": "5 分钟"
    },
    "kinio_recording.manual_length_seconds.preset.60": {
      "en": "1 minute (recommended)",
      "ja": "1 分（推奨）",
      "zh-Hans": "1 分钟（建议）"
    },
    "kinio_recording.manual_record_start": {
      "en": "Start manual recording",
      "ja": "手動録画を開始",
      "zh-Hans": "开始手动录像"
    },
    "kinio_recording.manual_record_stop": {
      "en": "Stop manual recording",
      "ja": "手動録画を停止",
      "zh-Hans": "停止手动录像"
    },
    "kinio_recording.normal_schedule": {
      "en": "Continuous recording hours",
      "ja": "常時録画の時間帯",
      "zh-Hans": "一般录像时段"
    },
    "kinio_recording.normal_schedule.help": {
      "en": "Shown in the list as \"Recording: Continuous / Only when there's activity / Custom\"; the grid is on the edit page.",
      "ja": "一覧では「録画方式：常時 / 動きがあったときだけ / カスタム」と表示し、時間表は編集画面にあります。",
      "zh-Hans": "列表上以「录像方式：全时 / 有动静才录 / 自订」呈现，格子在编辑页"
    },
    "kinio_recording.pack_time_minutes": {
      "en": "Segment length",
      "ja": "分割の長さ",
      "zh-Hans": "分段长度"
    },
    "kinio_recording.pre_record_seconds": {
      "en": "Pre-recording",
      "ja": "事前録画",
      "zh-Hans": "事前录像"
    },
    "kinio_recording.pre_record_seconds.preset.0": {
      "en": "Off",
      "ja": "録画しない",
      "zh-Hans": "不录"
    },
    "kinio_recording.pre_record_seconds.preset.10": {
      "en": "10 seconds",
      "ja": "10 秒",
      "zh-Hans": "10 秒"
    },
    "kinio_recording.pre_record_seconds.preset.3": {
      "en": "3 seconds",
      "ja": "3 秒",
      "zh-Hans": "3 秒"
    },
    "kinio_recording.pre_record_seconds.preset.5": {
      "en": "5 seconds (recommended)",
      "ja": "5 秒（推奨）",
      "zh-Hans": "5 秒（建议）"
    },
    "kinio_recording.quality": {
      "en": "Recording quality",
      "ja": "録画画質",
      "zh-Hans": "录像画质"
    },
    "kinio_recording.quality.enum.1080p": {
      "en": "1080p",
      "ja": "1080p",
      "zh-Hans": "1080p"
    },
    "kinio_recording.quality.enum.2k": {
      "en": "2K",
      "ja": "2K",
      "zh-Hans": "2K"
    },
    "kinio_recording.quality.enum.4k": {
      "en": "4K",
      "ja": "4K",
      "zh-Hans": "4K"
    },
    "kinio_recording.quality.enum.720p": {
      "en": "720p",
      "ja": "720p",
      "zh-Hans": "720p"
    },
    "kinio_recording.recording": {
      "en": "Recording",
      "ja": "録画中",
      "zh-Hans": "录像中"
    },
    "kinio_recording.retention_days": {
      "en": "Days to keep",
      "ja": "保存日数",
      "zh-Hans": "保留天数"
    },
    "kinio_recording.schedule": {
      "en": "Recording schedule",
      "ja": "録画スケジュール",
      "zh-Hans": "录像排程"
    },
    "kinio_recording.sd_enabled": {
      "en": "Record to memory card",
      "ja": "メモリーカードに録画",
      "zh-Hans": "录到存储卡"
    },
    "kinio_recording.sd_mode": {
      "en": "Memory card recording",
      "ja": "メモリーカードの録画方式",
      "zh-Hans": "存储卡录像方式"
    },
    "kinio_recording.sd_mode.enum.continuous": {
      "en": "Continuous",
      "ja": "常時録画",
      "zh-Hans": "全时录像"
    },
    "kinio_recording.sd_mode.enum.event": {
      "en": "Only when there's activity",
      "ja": "動きがあったときだけ録画",
      "zh-Hans": "有动静才录"
    },
    "kinio_recording.stream_mode": {
      "en": "Recording stream",
      "ja": "録画ストリーム",
      "zh-Hans": "录像串流"
    },
    "kinio_recording.stream_mode.enum.dual": {
      "en": "Main and sub stream",
      "ja": "メイン＋サブストリーム",
      "zh-Hans": "主码流加子码流"
    },
    "kinio_recording.stream_mode.enum.main": {
      "en": "Main stream",
      "ja": "メインストリーム",
      "zh-Hans": "主码流"
    },
    "kinio_recording.stream_mode.enum.sub": {
      "en": "Sub stream",
      "ja": "サブストリーム",
      "zh-Hans": "子码流"
    },
    "kinio_sensor_alert.humidity_lower_limit": {
      "en": "Humidity lower limit",
      "ja": "湿度の下限",
      "zh-Hans": "湿度下限"
    },
    "kinio_sensor_alert.humidity_upper_limit": {
      "en": "Humidity upper limit",
      "ja": "湿度の上限",
      "zh-Hans": "湿度上限"
    },
    "kinio_sensor_alert.temp_lower_limit": {
      "en": "Temperature lower limit",
      "ja": "温度の下限",
      "zh-Hans": "温度下限"
    },
    "kinio_sensor_alert.temp_upper_limit": {
      "en": "Temperature upper limit",
      "ja": "温度の上限",
      "zh-Hans": "温度上限"
    },
    "kinio_siren.alarm_enabled": {
      "en": "Sound automatically when a person is detected",
      "ja": "人を検知したら自動で鳴らす",
      "zh-Hans": "侦测到人时自动鸣响"
    },
    "kinio_siren.custom_sound": {
      "en": "Custom sound",
      "ja": "カスタム音",
      "zh-Hans": "自订音效"
    },
    "kinio_siren.remove_custom_sound": {
      "en": "Delete custom sound",
      "ja": "カスタム音を削除",
      "zh-Hans": "删除自订音效"
    },
    "kinio_siren.remove_custom_sound.confirm": {
      "en": "The custom sound will be deleted.",
      "ja": "カスタム音が削除されます。",
      "zh-Hans": "自订音效会被删除。"
    },
    "kinio_siren.schedule": {
      "en": "Active hours",
      "ja": "有効な時間帯",
      "zh-Hans": "生效时段"
    },
    "kinio_siren.siren_duration_seconds": {
      "en": "Duration",
      "ja": "継続時間",
      "zh-Hans": "持续时间"
    },
    "kinio_siren.siren_duration_seconds.preset.10": {
      "en": "10 seconds",
      "ja": "10 秒",
      "zh-Hans": "10 秒"
    },
    "kinio_siren.siren_duration_seconds.preset.120": {
      "en": "2 minutes",
      "ja": "2 分",
      "zh-Hans": "2 分钟"
    },
    "kinio_siren.siren_duration_seconds.preset.30": {
      "en": "30 seconds",
      "ja": "30 秒",
      "zh-Hans": "30 秒"
    },
    "kinio_siren.siren_duration_seconds.preset.60": {
      "en": "1 minute",
      "ja": "1 分",
      "zh-Hans": "1 分钟"
    },
    "kinio_siren.siren_type": {
      "en": "Sound",
      "ja": "音",
      "zh-Hans": "音效"
    },
    "kinio_siren.siren_type.enum.audio1": {
      "en": "Sound 1",
      "ja": "音 1",
      "zh-Hans": "音效 1"
    },
    "kinio_siren.siren_type.enum.audio2": {
      "en": "Sound 2",
      "ja": "音 2",
      "zh-Hans": "音效 2"
    },
    "kinio_siren.siren_type.enum.audio3": {
      "en": "Sound 3",
      "ja": "音 3",
      "zh-Hans": "音效 3"
    },
    "kinio_siren.siren_type.enum.siren": {
      "en": "Siren",
      "ja": "サイレン",
      "zh-Hans": "警笛"
    },
    "kinio_siren.siren_volume": {
      "en": "Volume",
      "ja": "音量",
      "zh-Hans": "音量"
    },
    "kinio_siren.stop": {
      "en": "Stop the siren",
      "ja": "サイレンを止める",
      "zh-Hans": "停止警报"
    },
    "kinio_siren.trigger": {
      "en": "Sound the siren",
      "ja": "サイレンを鳴らす",
      "zh-Hans": "触发警报"
    },
    "kinio_sleep_session.recording": {
      "en": "Recording",
      "ja": "記録中",
      "zh-Hans": "记录中"
    },
    "kinio_sleep_session.upload_enabled": {
      "en": "Data collection",
      "ja": "データ収集",
      "zh-Hans": "数据收集"
    },
    "kinio_sound_detection.enabled": {
      "en": "Sound detection",
      "ja": "音検知",
      "zh-Hans": "声音侦测"
    },
    "kinio_sound_detection.level": {
      "en": "Trigger level",
      "ja": "検知する音量",
      "zh-Hans": "触发音量"
    },
    "kinio_sound_detection.level.help": {
      "en": "Range in dB still to be measured on hardware (AlphaSeries config.soundDLvl); afterwards switch to Low / Medium / High presets and move to advanced.",
      "ja": "値の範囲（dB）は実機で計測予定（AlphaSeries config.soundDLvl）。計測後に低 / 中 / 高のプリセットに変更し、詳細設定へ移動します。",
      "zh-Hans": "值域待实机量 dB（AlphaSeries config.soundDLvl）；量好后改 presets 低 / 中 / 高、升高级"
    },
    "kinio_sound_recognition.enabled": {
      "en": "Sound recognition",
      "ja": "音の認識",
      "zh-Hans": "声音辨识"
    },
    "kinio_soundscape.adaptive": {
      "en": "Adapt to ambient noise",
      "ja": "周囲の音に合わせる",
      "zh-Hans": "环境声自适应"
    },
    "kinio_soundscape.adaptive_max_volume": {
      "en": "Adaptive volume limit",
      "ja": "自動調整の音量上限",
      "zh-Hans": "自适应音量上限"
    },
    "kinio_soundscape.fade_seconds": {
      "en": "Fade (seconds)",
      "ja": "フェード（秒）",
      "zh-Hans": "淡入淡出（秒）"
    },
    "kinio_soundscape.play": {
      "en": "Play",
      "ja": "再生",
      "zh-Hans": "播放"
    },
    "kinio_soundscape.playing": {
      "en": "Playing",
      "ja": "再生中",
      "zh-Hans": "播放中"
    },
    "kinio_soundscape.sound_id": {
      "en": "Sound",
      "ja": "音",
      "zh-Hans": "音效"
    },
    "kinio_soundscape.sound_id.help": {
      "en": "Choose from the sound list (sounds page in the health app)",
      "ja": "サウンド一覧から選びます（ヘルスアプリのサウンド画面）",
      "zh-Hans": "从音效清单选（健康 App 的音效页）"
    },
    "kinio_soundscape.stop": {
      "en": "Stop",
      "ja": "停止",
      "zh-Hans": "停止"
    },
    "kinio_soundscape.timer_minutes": {
      "en": "Sleep timer",
      "ja": "オフタイマー",
      "zh-Hans": "定时关闭"
    },
    "kinio_soundscape.timer_minutes.preset.120": {
      "en": "2 hours",
      "ja": "2 時間",
      "zh-Hans": "2 小时"
    },
    "kinio_soundscape.timer_minutes.preset.15": {
      "en": "15 minutes",
      "ja": "15 分",
      "zh-Hans": "15 分钟"
    },
    "kinio_soundscape.timer_minutes.preset.30": {
      "en": "30 minutes",
      "ja": "30 分",
      "zh-Hans": "30 分钟"
    },
    "kinio_soundscape.timer_minutes.preset.60": {
      "en": "1 hour",
      "ja": "1 時間",
      "zh-Hans": "1 小时"
    },
    "kinio_soundscape.volume": {
      "en": "Volume",
      "ja": "音量",
      "zh-Hans": "音量"
    },
    "kinio_station.gateway_enabled": {
      "en": "Let PoE devices reach the internet",
      "ja": "PoE 機器をインターネットにつなぐ",
      "zh-Hans": "让 PoE 设备连上网络"
    },
    "kinio_station.gateway_enabled.confirm": {
      "en": "Devices plugged into this unit's PoE ports will reach the internet through it. Turn this on?",
      "ja": "この本体の PoE ポートにつないだ機器が、この本体経由でインターネットにつながります。オンにしますか？",
      "zh-Hans": "接在这台 PoE 口上的设备会经这台连上网络。确定要开启？"
    },
    "kinio_station.gateway_enabled.help": {
      "en": "When on, devices on this unit's PoE ports reach the internet through it; when off, they can only talk to this unit",
      "ja": "オンにすると PoE ポートの機器はこの本体経由でインターネットにつながります。オフのときはこの本体とだけ通信できます",
      "zh-Hans": "开启后接在这台 PoE 口上的设备会经这台连上网络；关闭时它们只能连这台"
    },
    "kinio_station.gateway_status": {
      "en": "Internet sharing status",
      "ja": "インターネット共有の状態",
      "zh-Hans": "出网状态"
    },
    "kinio_station.poe_budget": {
      "en": "PoE power",
      "ja": "PoE 電力",
      "zh-Hans": "PoE 用电"
    },
    "kinio_station.poe_ports": {
      "en": "PoE ports",
      "ja": "PoE ポート",
      "zh-Hans": "PoE 口"
    },
    "kinio_station.poe_set": {
      "en": "PoE port power",
      "ja": "PoE ポート給電",
      "zh-Hans": "PoE 口供电"
    },
    "kinio_station.poe_set.confirm": {
      "en": "The device on this port will lose power.",
      "ja": "このポートの機器の電源が切れます。",
      "zh-Hans": "这个口上的设备会断电。"
    },
    "kinio_station.poe_set.help": {
      "en": "Turn a single port off / on / power-cycle it (restarts the camera on it)",
      "ja": "ポートごとに電源オフ / オン / 再給電（そのカメラを再起動するのと同じ）",
      "zh-Hans": "单口断电 / 开启 / 重新上电（等于让那台摄像头重启）"
    },
    "kinio_station.ui_home": {
      "en": "Local home screen",
      "ja": "本体のホーム画面",
      "zh-Hans": "本机首页"
    },
    "kinio_station.ui_home.enum.live": {
      "en": "Live multi-view wall",
      "ja": "ライブ分割ウォール",
      "zh-Hans": "实时多格墙"
    },
    "kinio_station.ui_home.enum.seat": {
      "en": "Workstation page",
      "ja": "ワークステーション画面",
      "zh-Hans": "工位页"
    },
    "kinio_station.ui_home.help": {
      "en": "Which page this Kinio Station's local screen opens to; embedded NVRs always show the live multi-view wall (this setting doesn't appear)",
      "ja": "この Kinio Station の本体画面で最初に開くページ。組み込み NVR は常にライブ分割ウォール（この設定は表示されません）",
      "zh-Hans": "这台 Kinio Station 的本机画面开到哪一页；嵌入式 NVR 一律实时多格墙（不会出现这个设置）"
    },
    "kinio_storage.disks": {
      "en": "Hard drives",
      "ja": "ハードディスク",
      "zh-Hans": "硬盘"
    },
    "kinio_storage.format": {
      "en": "Format",
      "ja": "フォーマット",
      "zh-Hans": "格式化"
    },
    "kinio_storage.format.confirm": {
      "en": "All recordings on the memory card or hard drive will be deleted and can't be recovered.",
      "ja": "メモリーカードまたはハードディスク上のすべての録画が削除され、元に戻せません。",
      "zh-Hans": "存储卡或硬盘上的所有录像会被删除且无法复原。"
    },
    "kinio_storage.formatting": {
      "en": "Formatting",
      "ja": "フォーマット中",
      "zh-Hans": "格式化中"
    },
    "kinio_storage.free_bytes": {
      "en": "Free space",
      "ja": "空き容量",
      "zh-Hans": "可用容量"
    },
    "kinio_storage.overwrite": {
      "en": "When storage is full",
      "ja": "容量が足りないとき",
      "zh-Hans": "空间不足时"
    },
    "kinio_storage.overwrite.preset.-1": {
      "en": "Overwrite the oldest (recommended)",
      "ja": "古いものから上書き（推奨）",
      "zh-Hans": "自动覆盖最旧的（建议）"
    },
    "kinio_storage.overwrite.preset.0": {
      "en": "Stop recording",
      "ja": "録画を停止",
      "zh-Hans": "停止录像"
    },
    "kinio_storage.overwrite.preset.30": {
      "en": "Keep 30 days",
      "ja": "30 日間保存",
      "zh-Hans": "保留 30 天"
    },
    "kinio_storage.overwrite.preset.7": {
      "en": "Keep 7 days",
      "ja": "7 日間保存",
      "zh-Hans": "保留 7 天"
    },
    "kinio_storage.quota_bytes": {
      "en": "Recording space limit",
      "ja": "録画容量の上限",
      "zh-Hans": "录像空间上限"
    },
    "kinio_storage.quota_bytes.help": {
      "en": "Past the limit, the oldest recordings are overwritten first",
      "ja": "上限を超えると古い録画から上書きします",
      "zh-Hans": "超过上限时从最旧的录像开始覆盖"
    },
    "kinio_storage.record_kbps": {
      "en": "Write rate",
      "ja": "書き込み速度",
      "zh-Hans": "写入速率"
    },
    "kinio_storage.reserve_gb": {
      "en": "Reserved space",
      "ja": "予約領域",
      "zh-Hans": "保留空间"
    },
    "kinio_storage.sd_capacity": {
      "en": "Memory card capacity",
      "ja": "メモリーカードの容量",
      "zh-Hans": "存储卡容量"
    },
    "kinio_storage.sd_capacity.help": {
      "en": "The SD card page shows capacity and how many days it can hold",
      "ja": "SD カードの画面に容量と保存できる日数を表示します",
      "zh-Hans": "SD 卡页显示容量与可存天数"
    },
    "kinio_storage.sd_format_type": {
      "en": "Storage format",
      "ja": "保存方式",
      "zh-Hans": "存储方式"
    },
    "kinio_storage.sd_format_type.confirm": {
      "en": "Changing the storage format reformats the memory card. With \"Playable on a computer\", anyone who takes the card can watch the recordings.",
      "ja": "保存方式を変えるとメモリーカードを再フォーマットします。「パソコンで直接再生可能」の場合、カードを持ち去られると誰でも録画を見られます。",
      "zh-Hans": "换存储方式要重新格式化存储卡；选「电脑可直接播放」时，卡被拿走任何人都看得到录像。"
    },
    "kinio_storage.sd_format_type.enum.chunk_ring": {
      "en": "Multi-channel",
      "ja": "マルチチャンネル",
      "zh-Hans": "多通道"
    },
    "kinio_storage.sd_format_type.enum.fmp4": {
      "en": "Playable on a computer",
      "ja": "パソコンで直接再生可能",
      "zh-Hans": "电脑可直接播放"
    },
    "kinio_storage.sd_format_type.enum.lsraw": {
      "en": "Standard (encrypted)",
      "ja": "標準（暗号化）",
      "zh-Hans": "一般（加密）"
    },
    "kinio_storage.sd_present": {
      "en": "Memory card",
      "ja": "メモリーカード",
      "zh-Hans": "存储卡"
    },
    "kinio_storage.sd_status": {
      "en": "Memory card status",
      "ja": "メモリーカードの状態",
      "zh-Hans": "存储卡状态"
    },
    "kinio_storage.sd_status.enum.abnormal": {
      "en": "Error",
      "ja": "異常",
      "zh-Hans": "异常"
    },
    "kinio_storage.sd_status.enum.formatting": {
      "en": "Formatting",
      "ja": "フォーマット中",
      "zh-Hans": "格式化中"
    },
    "kinio_storage.sd_status.enum.needs_format": {
      "en": "Needs formatting",
      "ja": "フォーマットが必要",
      "zh-Hans": "需要格式化"
    },
    "kinio_storage.sd_status.enum.no_sd": {
      "en": "No memory card",
      "ja": "メモリーカードなし",
      "zh-Hans": "没有存储卡"
    },
    "kinio_storage.sd_status.enum.no_space": {
      "en": "Storage full",
      "ja": "空き容量がありません",
      "zh-Hans": "空间已满"
    },
    "kinio_storage.sd_status.enum.normal": {
      "en": "Normal",
      "ja": "正常",
      "zh-Hans": "正常"
    },
    "kinio_storage.smart": {
      "en": "Drive health",
      "ja": "ディスクの健康状態",
      "zh-Hans": "硬盘健康"
    },
    "kinio_storage.smart_auto_test": {
      "en": "Weekly automatic health check",
      "ja": "毎週の自動ヘルスチェック",
      "zh-Hans": "每周自动健检"
    },
    "kinio_storage.smart_auto_test.help": {
      "en": "Runs a short self-test on the hard drive once a week without interrupting recording; you'll be notified if it fails.",
      "ja": "週に 1 回ハードディスクの短時間セルフテストを実行します。録画は止まりません。失敗した場合は通知します。",
      "zh-Hans": "每周对硬盘运行一次短时间自检，录像不中断；失败会通知"
    },
    "kinio_storage.smart_test": {
      "en": "Drive health check",
      "ja": "ディスクの診断",
      "zh-Hans": "硬盘检测"
    },
    "kinio_storage.total_bytes": {
      "en": "Total capacity",
      "ja": "総容量",
      "zh-Hans": "总容量"
    },
    "kinio_storage.unmount": {
      "en": "Safely remove memory card",
      "ja": "メモリーカードを安全に取り外す",
      "zh-Hans": "安全移除存储卡"
    },
    "kinio_streaming.supported_codecs": {
      "en": "Supported codecs",
      "ja": "対応コーデック",
      "zh-Hans": "支持编码"
    },
    "kinio_streaming.video_channel_info": {
      "en": "Stream channels",
      "ja": "ストリームチャンネル",
      "zh-Hans": "串流通道"
    },
    "kinio_system.channel_online_summary": {
      "en": "Channel summary",
      "ja": "チャンネル概要",
      "zh-Hans": "通道摘要"
    },
    "kinio_system.device_temperature": {
      "en": "Device temperature",
      "ja": "本体温度",
      "zh-Hans": "机体温度"
    },
    "kinio_system.device_time": {
      "en": "Device time",
      "ja": "デバイスの時刻",
      "zh-Hans": "设备时间"
    },
    "kinio_system.factory_reset": {
      "en": "Factory reset",
      "ja": "工場出荷時設定に戻す",
      "zh-Hans": "原厂重置"
    },
    "kinio_system.factory_reset.confirm": {
      "en": "All settings will be erased and can't be recovered. The device will need to be paired again.",
      "ja": "すべての設定が消去され、元に戻せません。デバイスを再度ペアリングする必要があります。",
      "zh-Hans": "所有设置会被清除且无法复原，设备需要重新配对。"
    },
    "kinio_system.fan_status": {
      "en": "Fan",
      "ja": "ファン",
      "zh-Hans": "风扇"
    },
    "kinio_system.fan_status.enum.absent": {
      "en": "No fan",
      "ja": "ファンなし",
      "zh-Hans": "没有风扇"
    },
    "kinio_system.fan_status.enum.error": {
      "en": "Error",
      "ja": "異常",
      "zh-Hans": "异常"
    },
    "kinio_system.fan_status.enum.normal": {
      "en": "Normal",
      "ja": "正常",
      "zh-Hans": "正常"
    },
    "kinio_system.hdd_free_gb": {
      "en": "Free space",
      "ja": "空き容量",
      "zh-Hans": "可用容量"
    },
    "kinio_system.hdd_status": {
      "en": "Hard drive status",
      "ja": "ハードディスクの状態",
      "zh-Hans": "硬盘状态"
    },
    "kinio_system.hdd_status.enum.degraded": {
      "en": "Degraded",
      "ja": "性能低下",
      "zh-Hans": "性能降低"
    },
    "kinio_system.hdd_status.enum.error": {
      "en": "Error",
      "ja": "異常",
      "zh-Hans": "异常"
    },
    "kinio_system.hdd_status.enum.missing": {
      "en": "No hard drive",
      "ja": "ハードディスクなし",
      "zh-Hans": "没有硬盘"
    },
    "kinio_system.hdd_status.enum.normal": {
      "en": "Normal",
      "ja": "正常",
      "zh-Hans": "正常"
    },
    "kinio_system.ip": {
      "en": "IP address",
      "ja": "IP アドレス",
      "zh-Hans": "IP 地址"
    },
    "kinio_system.ip6": {
      "en": "IPv6 address",
      "ja": "IPv6 アドレス",
      "zh-Hans": "IPv6 地址"
    },
    "kinio_system.net_mode": {
      "en": "Network mode",
      "ja": "ネットワークモード",
      "zh-Hans": "网络模式"
    },
    "kinio_system.net_mode.enum.ap": {
      "en": "Offline mode (AP)",
      "ja": "オフラインモード（AP）",
      "zh-Hans": "离线模式（AP）"
    },
    "kinio_system.net_mode.enum.sta": {
      "en": "Normal (Wi-Fi)",
      "ja": "通常（Wi-Fi）",
      "zh-Hans": "一般（Wi-Fi）"
    },
    "kinio_system.net_mode.help": {
      "en": "Shown and switched on the app's “Offline mode (AP)” card",
      "ja": "アプリの「オフラインモード（AP）」カードで表示・切り替え",
      "zh-Hans": "在 App 的「离线模式（AP）」卡显示与切换"
    },
    "kinio_system.network_status": {
      "en": "Network status",
      "ja": "ネットワーク状態",
      "zh-Hans": "网络状态"
    },
    "kinio_system.network_status.enum.degraded": {
      "en": "Unstable",
      "ja": "不安定",
      "zh-Hans": "不稳定"
    },
    "kinio_system.network_status.enum.normal": {
      "en": "Normal",
      "ja": "正常",
      "zh-Hans": "正常"
    },
    "kinio_system.network_status.enum.offline": {
      "en": "Offline",
      "ja": "オフライン",
      "zh-Hans": "离线"
    },
    "kinio_system.online": {
      "en": "Connection",
      "ja": "接続状態",
      "zh-Hans": "连接状态"
    },
    "kinio_system.ota_start": {
      "en": "Check for firmware update",
      "ja": "ファームウェアの更新を確認",
      "zh-Hans": "检查固件更新"
    },
    "kinio_system.reboot": {
      "en": "Restart",
      "ja": "再起動",
      "zh-Hans": "重新启动"
    },
    "kinio_system.reboot.confirm": {
      "en": "The device will restart. This takes about a minute.",
      "ja": "デバイスが再起動します。約 1 分かかります。",
      "zh-Hans": "设备会重新启动，约需一分钟。"
    },
    "kinio_system.reset_keep_wifi": {
      "en": "Reset but keep Wi-Fi",
      "ja": "Wi-Fi を残してリセット",
      "zh-Hans": "重设但保留 Wi-Fi"
    },
    "kinio_system.reset_keep_wifi.confirm": {
      "en": "Everything except Wi-Fi settings will be erased.",
      "ja": "Wi-Fi 設定以外はすべて消去されます。",
      "zh-Hans": "除了 Wi-Fi 设置之外都会被清除。"
    },
    "kinio_system.timezone": {
      "en": "Time zone",
      "ja": "タイムゾーン",
      "zh-Hans": "时区"
    },
    "kinio_system.wifi_signal_percent": {
      "en": "Signal strength",
      "ja": "信号強度",
      "zh-Hans": "信号强度"
    },
    "kinio_system.wifi_ssid": {
      "en": "Wi-Fi network",
      "ja": "Wi-Fi ネットワーク",
      "zh-Hans": "Wi-Fi 网络"
    },
    "kinio_tamper.enabled": {
      "en": "Tamper detection",
      "ja": "遮蔽検知",
      "zh-Hans": "遮挡侦测"
    },
    "kinio_thermostat_ext.lower_setpoint": {
      "en": "Temperature lower limit",
      "ja": "温度の下限",
      "zh-Hans": "温度下限"
    },
    "kinio_thermostat_ext.upper_setpoint": {
      "en": "Temperature upper limit",
      "ja": "温度の上限",
      "zh-Hans": "温度上限"
    },
    "kinio_tv.channel_number": {
      "en": "Channel",
      "ja": "チャンネル",
      "zh-Hans": "频道"
    },
    "kinio_tv.muted": {
      "en": "Mute",
      "ja": "ミュート",
      "zh-Hans": "静音"
    },
    "kinio_tv.volume": {
      "en": "Volume",
      "ja": "音量",
      "zh-Hans": "音量"
    },
    "kinio_video.main_codec": {
      "en": "Main stream encoding",
      "ja": "メインストリームのエンコード",
      "zh-Hans": "主串流编码"
    },
    "kinio_video.main_codec.enum.h264": {
      "en": "H.264",
      "ja": "H.264",
      "zh-Hans": "H.264"
    },
    "kinio_video.main_codec.enum.h265": {
      "en": "H.265",
      "ja": "H.265",
      "zh-Hans": "H.265"
    },
    "kinio_video.main_codec.help": {
      "en": "H.265 saves bandwidth at the same quality, but some players do not support it; live view in the app switches to the sub stream. Changes take effect after a restart",
      "ja": "H.265 は同じ画質で帯域を節約できますが、一部のプレーヤーは対応していません。アプリのライブ映像はサブストリームに切り替わります。変更は再起動後に反映されます",
      "zh-Hans": "H.265 同画质较省带宽，但部分播放器不支持；App 实时画面会改看次串流。变更后需重新启动才会生效"
    },
    "kinio_video.main_fps": {
      "en": "Main stream frame rate",
      "ja": "メインストリームのフレームレート",
      "zh-Hans": "主串流帧率"
    },
    "kinio_video.main_fps.help": {
      "en": "Frames per second; lower saves bandwidth but motion looks choppier",
      "ja": "1 秒あたりのコマ数。下げると通信量を節約できますが、動きがカクつきます",
      "zh-Hans": "每秒几张画面；调低比较省网络，动作会比较不连贯"
    },
    "kinio_video.main_gop": {
      "en": "Main stream keyframe interval",
      "ja": "メインストリームのキーフレーム間隔",
      "zh-Hans": "主串流关键帧间隔"
    },
    "kinio_video.main_gop.help": {
      "en": "How often a full frame is sent; longer saves bandwidth but starting and scrubbing playback are slower",
      "ja": "何コマごとに完全な画像を入れるか。長いほど通信量を節約できますが、再生開始やシークが遅くなります",
      "zh-Hans": "几张画面插一张完整画面；越长越省网络，开始播放与拖动回放会比较慢"
    },
    "kinio_video.main_kbps": {
      "en": "Main stream bitrate",
      "ja": "メインストリームのビットレート",
      "zh-Hans": "主串流码率"
    },
    "kinio_video.main_kbps.help": {
      "en": "A trade-off between detail and data use; lower saves bandwidth and storage",
      "ja": "画質と通信量のバランス。下げると通信量と保存容量を節約できます",
      "zh-Hans": "画面细节与用量的取舍；调低比较省网络与存储空间"
    },
    "kinio_video.main_resolution": {
      "en": "Main stream resolution",
      "ja": "メインストリームの解像度",
      "zh-Hans": "主串流分辨率"
    },
    "kinio_video.sensor_fps": {
      "en": "Sensor frame rate",
      "ja": "センサーのフレームレート",
      "zh-Hans": "传感器帧率"
    },
    "kinio_video.sensor_fps.enum.fps15": {
      "en": "15 fps",
      "ja": "15 fps",
      "zh-Hans": "15 fps"
    },
    "kinio_video.sensor_fps.enum.fps20": {
      "en": "20 fps",
      "ja": "20 fps",
      "zh-Hans": "20 fps"
    },
    "kinio_video.sensor_fps.enum.fps25": {
      "en": "25 fps",
      "ja": "25 fps",
      "zh-Hans": "25 fps"
    },
    "kinio_video.sensor_fps.enum.fps30": {
      "en": "30 fps",
      "ja": "30 fps",
      "zh-Hans": "30 fps"
    },
    "kinio_video.sensor_fps.help": {
      "en": "How many frames the lens captures per second; stream frame rates cannot exceed it. Changes take effect after a restart",
      "ja": "レンズが 1 秒間に撮影する枚数です。ストリームのフレームレートはこれを超えません。変更は再起動後に反映されます",
      "zh-Hans": "镜头每秒拍几张；串流帧率不会超过它。变更后需重新启动才会生效"
    },
    "kinio_video.sub_fps": {
      "en": "Sub stream frame rate",
      "ja": "サブストリームのフレームレート",
      "zh-Hans": "次串流帧率"
    },
    "kinio_video.sub_gop": {
      "en": "Sub stream keyframe interval",
      "ja": "サブストリームのキーフレーム間隔",
      "zh-Hans": "次串流关键帧间隔"
    },
    "kinio_video.sub_kbps": {
      "en": "Sub stream bitrate",
      "ja": "サブストリームのビットレート",
      "zh-Hans": "次串流码率"
    },
    "kinio_video.sub_kbps.help": {
      "en": "Lower saves bandwidth",
      "ja": "下げると通信量を節約できます",
      "zh-Hans": "调低比较省网络"
    },
    "kinio_video.sub_resolution": {
      "en": "Sub stream resolution",
      "ja": "サブストリームの解像度",
      "zh-Hans": "次串流分辨率"
    },
    "kinio_video_signal.signal_format": {
      "en": "Signal format",
      "ja": "信号形式",
      "zh-Hans": "信号格式"
    },
    "kinio_video_signal.signal_format.enum.ahd": {
      "en": "AHD",
      "ja": "AHD",
      "zh-Hans": "AHD"
    },
    "kinio_video_signal.signal_format.enum.analog": {
      "en": "Analog",
      "ja": "アナログ",
      "zh-Hans": "模拟"
    },
    "kinio_video_signal.signal_format.enum.cvi": {
      "en": "HD-CVI",
      "ja": "HD-CVI",
      "zh-Hans": "HD-CVI"
    },
    "kinio_video_signal.signal_format.enum.ip": {
      "en": "IP camera",
      "ja": "ネットワークカメラ",
      "zh-Hans": "网络摄像头"
    },
    "kinio_video_signal.signal_format.enum.tvi": {
      "en": "HD-TVI",
      "ja": "HD-TVI",
      "zh-Hans": "HD-TVI"
    },
    "kinio_video_signal.signal_format.enum.unknown": {
      "en": "Unknown",
      "ja": "不明",
      "zh-Hans": "未知"
    },
    "kinio_video_signal.signal_present": {
      "en": "Signal",
      "ja": "信号",
      "zh-Hans": "信号"
    },
    "kinio_video_signal.video_loss_enabled": {
      "en": "Notify when video signal is lost",
      "ja": "映像信号が途切れたら通知",
      "zh-Hans": "影像信号中断时通知"
    },
    "laundry_washer_mode.current_mode": {
      "en": "Wash mode",
      "ja": "洗濯モード",
      "zh-Hans": "洗衣模式"
    },
    "laundry_washer_mode.current_mode.enum.delicate": {
      "en": "Delicate",
      "ja": "おしゃれ着",
      "zh-Hans": "轻柔"
    },
    "laundry_washer_mode.current_mode.enum.heavy": {
      "en": "Heavy",
      "ja": "強力",
      "zh-Hans": "强力"
    },
    "laundry_washer_mode.current_mode.enum.normal": {
      "en": "Normal",
      "ja": "標準",
      "zh-Hans": "标准"
    },
    "laundry_washer_mode.current_mode.enum.whites": {
      "en": "Whites",
      "ja": "白物",
      "zh-Hans": "白色衣物"
    },
    "level_control.current_level": {
      "en": "Brightness",
      "ja": "明るさ",
      "zh-Hans": "亮度"
    },
    "media_input.current_input": {
      "en": "Input source",
      "ja": "入力ソース",
      "zh-Hans": "输入来源"
    },
    "media_input.current_input.enum.hdmi1": {
      "en": "HDMI 1",
      "ja": "HDMI 1",
      "zh-Hans": "HDMI 1"
    },
    "media_input.current_input.enum.hdmi2": {
      "en": "HDMI 2",
      "ja": "HDMI 2",
      "zh-Hans": "HDMI 2"
    },
    "media_input.current_input.enum.hdmi3": {
      "en": "HDMI 3",
      "ja": "HDMI 3",
      "zh-Hans": "HDMI 3"
    },
    "media_input.current_input.enum.tuner": {
      "en": "TV tuner",
      "ja": "テレビチューナー",
      "zh-Hans": "电视频道"
    },
    "media_input.current_input.enum.usb": {
      "en": "USB",
      "ja": "USB",
      "zh-Hans": "USB"
    },
    "media_playback.current_state": {
      "en": "Playback status",
      "ja": "再生状態",
      "zh-Hans": "播放状态"
    },
    "media_playback.current_state.enum.buffering": {
      "en": "Buffering",
      "ja": "バッファリング中",
      "zh-Hans": "缓冲中"
    },
    "media_playback.current_state.enum.not_playing": {
      "en": "Not playing",
      "ja": "停止中",
      "zh-Hans": "未播放"
    },
    "media_playback.current_state.enum.paused": {
      "en": "Paused",
      "ja": "一時停止中",
      "zh-Hans": "已暂停"
    },
    "media_playback.current_state.enum.playing": {
      "en": "Playing",
      "ja": "再生中",
      "zh-Hans": "播放中"
    },
    "media_playback.next": {
      "en": "Next",
      "ja": "次へ",
      "zh-Hans": "下一个"
    },
    "media_playback.pause": {
      "en": "Pause",
      "ja": "一時停止",
      "zh-Hans": "暂停"
    },
    "media_playback.play": {
      "en": "Play",
      "ja": "再生",
      "zh-Hans": "播放"
    },
    "media_playback.previous": {
      "en": "Previous",
      "ja": "前へ",
      "zh-Hans": "上一个"
    },
    "media_playback.stop": {
      "en": "Stop",
      "ja": "停止",
      "zh-Hans": "停止"
    },
    "occupancy_sensing.occupancy": {
      "en": "Occupied now",
      "ja": "現在在室",
      "zh-Hans": "目前有人"
    },
    "on_off.on": {
      "en": "Power",
      "ja": "電源",
      "zh-Hans": "电源"
    },
    "operational_state.countdown_time": {
      "en": "Time remaining",
      "ja": "残り時間",
      "zh-Hans": "剩余时间"
    },
    "operational_state.operational_state": {
      "en": "Operating status",
      "ja": "運転状態",
      "zh-Hans": "运转状态"
    },
    "operational_state.operational_state.enum.error": {
      "en": "Error",
      "ja": "エラー",
      "zh-Hans": "错误"
    },
    "operational_state.operational_state.enum.paused": {
      "en": "Paused",
      "ja": "一時停止中",
      "zh-Hans": "已暂停"
    },
    "operational_state.operational_state.enum.running": {
      "en": "Running",
      "ja": "運転中",
      "zh-Hans": "运转中"
    },
    "operational_state.operational_state.enum.stopped": {
      "en": "Stopped",
      "ja": "停止中",
      "zh-Hans": "已停止"
    },
    "operational_state.pause": {
      "en": "Pause",
      "ja": "一時停止",
      "zh-Hans": "暂停"
    },
    "operational_state.resume": {
      "en": "Resume",
      "ja": "再開",
      "zh-Hans": "继续"
    },
    "operational_state.start": {
      "en": "Start",
      "ja": "開始",
      "zh-Hans": "开始"
    },
    "operational_state.stop": {
      "en": "Stop",
      "ja": "停止",
      "zh-Hans": "停止"
    },
    "pm25_concentration_measurement.measured_value": {
      "en": "PM2.5",
      "ja": "PM2.5",
      "zh-Hans": "PM2.5"
    },
    "power_source.bat_charge_state": {
      "en": "Charging status",
      "ja": "充電状態",
      "zh-Hans": "充电状态"
    },
    "power_source.bat_charge_state.enum.charging": {
      "en": "Charging",
      "ja": "充電中",
      "zh-Hans": "充电中"
    },
    "power_source.bat_charge_state.enum.full": {
      "en": "Fully charged",
      "ja": "充電完了",
      "zh-Hans": "已充饱"
    },
    "power_source.bat_charge_state.enum.not_charging": {
      "en": "Not charging",
      "ja": "充電していません",
      "zh-Hans": "未充电"
    },
    "power_source.bat_charge_state.enum.unknown": {
      "en": "Unknown",
      "ja": "不明",
      "zh-Hans": "未知"
    },
    "power_source.bat_percent_remaining": {
      "en": "Battery",
      "ja": "バッテリー残量",
      "zh-Hans": "电量"
    },
    "power_source.wired_present": {
      "en": "External power",
      "ja": "外部電源",
      "zh-Hans": "外置电源"
    },
    "refrigerator_alarm.state": {
      "en": "Alarm status",
      "ja": "アラームの状態",
      "zh-Hans": "警报状态"
    },
    "refrigerator_alarm.state.enum.door_open": {
      "en": "Door open",
      "ja": "ドアが開いています",
      "zh-Hans": "门未关"
    },
    "refrigerator_alarm.state.enum.normal": {
      "en": "Normal",
      "ja": "正常",
      "zh-Hans": "正常"
    },
    "refrigerator_and_temperature_controlled_cabinet_mode.current_mode": {
      "en": "Refrigerator mode",
      "ja": "冷蔵庫モード",
      "zh-Hans": "冰箱模式"
    },
    "refrigerator_and_temperature_controlled_cabinet_mode.current_mode.enum.normal": {
      "en": "Normal",
      "ja": "標準",
      "zh-Hans": "标准"
    },
    "refrigerator_and_temperature_controlled_cabinet_mode.current_mode.enum.rapid_cool": {
      "en": "Rapid cool",
      "ja": "急速冷蔵",
      "zh-Hans": "急速冷藏"
    },
    "refrigerator_and_temperature_controlled_cabinet_mode.current_mode.enum.rapid_freeze": {
      "en": "Rapid freeze",
      "ja": "急速冷凍",
      "zh-Hans": "急速冷冻"
    },
    "relative_humidity_measurement.measured_value": {
      "en": "Humidity",
      "ja": "湿度",
      "zh-Hans": "湿度"
    },
    "rvc_clean_mode.current_mode": {
      "en": "Cleaning mode",
      "ja": "掃除モード",
      "zh-Hans": "清洁模式"
    },
    "rvc_clean_mode.current_mode.enum.mop": {
      "en": "Mop",
      "ja": "水拭き",
      "zh-Hans": "拖地"
    },
    "rvc_clean_mode.current_mode.enum.vacuum": {
      "en": "Vacuum",
      "ja": "吸引",
      "zh-Hans": "吸尘"
    },
    "rvc_clean_mode.current_mode.enum.vacuum_and_mop": {
      "en": "Vacuum and mop",
      "ja": "吸引＋水拭き",
      "zh-Hans": "吸尘加拖地"
    },
    "rvc_operational_state.go_home": {
      "en": "Return to dock",
      "ja": "充電台に戻る",
      "zh-Hans": "回充电座"
    },
    "rvc_operational_state.operational_state": {
      "en": "Operating status",
      "ja": "運転状態",
      "zh-Hans": "运转状态"
    },
    "rvc_operational_state.operational_state.enum.charging": {
      "en": "Charging",
      "ja": "充電中",
      "zh-Hans": "充电中"
    },
    "rvc_operational_state.operational_state.enum.docked": {
      "en": "Docked",
      "ja": "充電台にいます",
      "zh-Hans": "已回座"
    },
    "rvc_operational_state.operational_state.enum.error": {
      "en": "Error",
      "ja": "エラー",
      "zh-Hans": "错误"
    },
    "rvc_operational_state.operational_state.enum.paused": {
      "en": "Paused",
      "ja": "一時停止中",
      "zh-Hans": "已暂停"
    },
    "rvc_operational_state.operational_state.enum.running": {
      "en": "Cleaning",
      "ja": "掃除中",
      "zh-Hans": "清扫中"
    },
    "rvc_operational_state.operational_state.enum.seeking_charger": {
      "en": "Returning to dock",
      "ja": "充電台に戻っています",
      "zh-Hans": "返回充电座中"
    },
    "rvc_operational_state.operational_state.enum.stopped": {
      "en": "Stopped",
      "ja": "停止中",
      "zh-Hans": "已停止"
    },
    "rvc_operational_state.pause": {
      "en": "Pause",
      "ja": "一時停止",
      "zh-Hans": "暂停"
    },
    "rvc_operational_state.resume": {
      "en": "Resume cleaning",
      "ja": "掃除を再開",
      "zh-Hans": "继续清扫"
    },
    "rvc_run_mode.current_mode": {
      "en": "Run mode",
      "ja": "運転モード",
      "zh-Hans": "运转模式"
    },
    "rvc_run_mode.current_mode.enum.cleaning": {
      "en": "Clean",
      "ja": "掃除",
      "zh-Hans": "清扫"
    },
    "rvc_run_mode.current_mode.enum.idle": {
      "en": "Idle",
      "ja": "待機",
      "zh-Hans": "待机"
    },
    "rvc_run_mode.current_mode.enum.mapping": {
      "en": "Mapping",
      "ja": "マップ作成",
      "zh-Hans": "建图"
    },
    "section.air": {
      "en": "Air quality",
      "ja": "空気の質",
      "zh-Hans": "空气品质"
    },
    "section.appliance": {
      "en": "Appliance",
      "ja": "家電の運転",
      "zh-Hans": "家电运转"
    },
    "section.audio": {
      "en": "Audio",
      "ja": "音声",
      "zh-Hans": "音频"
    },
    "section.channels": {
      "en": "Channels",
      "ja": "チャンネル",
      "zh-Hans": "通道"
    },
    "section.climate": {
      "en": "Climate",
      "ja": "温度調節",
      "zh-Hans": "温控"
    },
    "section.control": {
      "en": "Control",
      "ja": "操作",
      "zh-Hans": "控制"
    },
    "section.detection": {
      "en": "Detection",
      "ja": "検知",
      "zh-Hans": "侦测"
    },
    "section.doorbell": {
      "en": "Doorbell",
      "ja": "ドアベル",
      "zh-Hans": "门铃"
    },
    "section.fan": {
      "en": "Fan",
      "ja": "ファン",
      "zh-Hans": "风扇"
    },
    "section.floodlight": {
      "en": "Floodlight",
      "ja": "フラッドライト",
      "zh-Hans": "补光灯"
    },
    "section.fridge": {
      "en": "Refrigerator",
      "ja": "冷蔵庫",
      "zh-Hans": "冰箱"
    },
    "section.health": {
      "en": "Device",
      "ja": "デバイス",
      "zh-Hans": "设备"
    },
    "section.image": {
      "en": "Image",
      "ja": "映像",
      "zh-Hans": "影像"
    },
    "section.light": {
      "en": "Night vision and lights",
      "ja": "ナイトビジョンとランプ",
      "zh-Hans": "夜视与指示灯"
    },
    "section.mycam": {
      "en": "Home watch",
      "ja": "見守り",
      "zh-Hans": "看家"
    },
    "section.network": {
      "en": "Network",
      "ja": "ネットワーク",
      "zh-Hans": "网络"
    },
    "section.plug": {
      "en": "Plug",
      "ja": "プラグ",
      "zh-Hans": "插座"
    },
    "section.ptz": {
      "en": "Pan and tilt",
      "ja": "パン・チルト",
      "zh-Hans": "云台"
    },
    "section.recording": {
      "en": "Recording",
      "ja": "録画",
      "zh-Hans": "录像"
    },
    "section.sensor": {
      "en": "Sensors",
      "ja": "センサー",
      "zh-Hans": "传感器"
    },
    "section.siren": {
      "en": "Siren",
      "ja": "サイレン",
      "zh-Hans": "警报器"
    },
    "section.sleep": {
      "en": "Sleep",
      "ja": "睡眠",
      "zh-Hans": "睡眠"
    },
    "section.storage": {
      "en": "Storage",
      "ja": "ストレージ",
      "zh-Hans": "存储"
    },
    "section.tv": {
      "en": "TV",
      "ja": "テレビ",
      "zh-Hans": "电视"
    },
    "section.vacuum": {
      "en": "Robot vacuum",
      "ja": "ロボット掃除機",
      "zh-Hans": "扫地机"
    },
    "segment.camera_state": {
      "en": "Camera status",
      "ja": "カメラの状態",
      "zh-Hans": "摄像头状态"
    },
    "segment.camera_state.none": {
      "en": "Normal",
      "ja": "正常",
      "zh-Hans": "正常"
    },
    "temperature_control.temperature_setpoint": {
      "en": "Target temperature",
      "ja": "設定温度",
      "zh-Hans": "目标温度"
    },
    "temperature_measurement.measured_value": {
      "en": "Temperature",
      "ja": "温度",
      "zh-Hans": "温度"
    },
    "thermostat.local_temperature": {
      "en": "Current temperature",
      "ja": "現在の温度",
      "zh-Hans": "目前温度"
    },
    "thermostat.occupied_cooling_setpoint": {
      "en": "Cooling target temperature",
      "ja": "冷房の設定温度",
      "zh-Hans": "冷气目标温度"
    },
    "thermostat.occupied_heating_setpoint": {
      "en": "Target temperature",
      "ja": "設定温度",
      "zh-Hans": "目标温度"
    },
    "thermostat.system_mode": {
      "en": "Mode",
      "ja": "モード",
      "zh-Hans": "模式"
    },
    "thermostat.system_mode.enum.auto": {
      "en": "Auto",
      "ja": "自動",
      "zh-Hans": "自动"
    },
    "thermostat.system_mode.enum.cool": {
      "en": "Cool",
      "ja": "冷房",
      "zh-Hans": "冷气"
    },
    "thermostat.system_mode.enum.dry": {
      "en": "Dry",
      "ja": "除湿",
      "zh-Hans": "除湿"
    },
    "thermostat.system_mode.enum.fan_only": {
      "en": "Fan only",
      "ja": "送風",
      "zh-Hans": "送风"
    },
    "thermostat.system_mode.enum.heat": {
      "en": "Heat",
      "ja": "暖房",
      "zh-Hans": "暖气"
    },
    "thermostat.system_mode.enum.off": {
      "en": "Off",
      "ja": "オフ",
      "zh-Hans": "关闭"
    },
    "kinio_recording.quality_tier": {
      "en": "Recording quality",
      "ja": "録画画質",
      "zh-Hans": "录像画质"
    },
    "kinio_recording.quality_tier.enum.high": {
      "en": "High",
      "ja": "高",
      "zh-Hans": "高"
    },
    "kinio_recording.quality_tier.enum.standard": {
      "en": "Standard",
      "ja": "標準",
      "zh-Hans": "标准"
    },
    "kinio_recording.quality_tier.help": {
      "en": "High = main stream (best picture); Standard = sub stream, smoother playback and more days on the memory card",
      "ja": "高 = メインストリーム（最高画質）。標準 = サブストリーム。再生がなめらかで、メモリーカードに残せる日数が増えます",
      "zh-Hans": "高 = 主码流（画质最好）；标准 = 子码流，回放较顺、存储卡可存的天数较多"
    }
  }
}
